export default {
  name: 'line-awesome',
  icons: [
    { name: 'la-500px', prefix: 'lab', tags: ['brand'] },
    { name: 'la-accessible-icon', prefix: 'lab', tags: ['accessibility', 'brand'] },
    { name: 'la-accusoft', prefix: 'lab', tags: ['brand'] },
    { name: 'la-acquisitions-incorporated', prefix: 'lab', tags: ['brand'] },
    { name: 'la-ad', prefix: 'las', tags: ['social'] },
    { name: 'la-address-book', prefix: 'las', tags: ['office', 'people'] },
    { name: 'la-address-card', prefix: 'las', tags: ['office', 'people'] },
    { name: 'la-adjust', prefix: 'las', tags: ['technology'] },
    { name: 'la-adn', prefix: 'lab', tags: ['brand'] },
    { name: 'la-adobe', prefix: 'lab', tags: ['brand'] },
    { name: 'la-adversal', prefix: 'lab', tags: ['brand'] },
    { name: 'la-affiliatetheme', prefix: 'lab', tags: ['brand'] },
    { name: 'la-air-freshener', prefix: 'las', tags: ['travel'] },
    { name: 'la-airbnb', prefix: 'lab', tags: ['brand'] },
    { name: 'la-algolia', prefix: 'lab', tags: ['brand'] },
    { name: 'la-align-center', prefix: 'las', tags: ['editor'] },
    { name: 'la-align-justify', prefix: 'las', tags: ['editor'] },
    { name: 'la-align-left', prefix: 'las', tags: ['editor'] },
    { name: 'la-align-right', prefix: 'las', tags: ['editor'] },
    { name: 'la-alipay', prefix: 'lab', tags: ['brand'] },
    { name: 'la-allergies', prefix: 'las', tags: ['health'] },
    { name: 'la-amazon', prefix: 'lab', tags: ['brand'] },
    { name: 'la-amazon-pay', prefix: 'lab', tags: ['brand'] },
    { name: 'la-ambulance', prefix: 'las', tags: ['travel'] },
    { name: 'la-american-sign-language-interpreting', prefix: 'las', tags: ['accessibility'] },
    { name: 'la-amilia', prefix: 'lab', tags: ['brand'] },
    { name: 'la-anchor', prefix: 'las', tags: ['brand'] },
    { name: 'la-android', prefix: 'lab', tags: ['brand'] },
    { name: 'la-angellist', prefix: 'lab', tags: ['brand'] },
    { name: 'la-angle-double-down', prefix: 'las', tags: ['arrow'] },
    { name: 'la-angle-double-left', prefix: 'las', tags: ['arrow'] },
    { name: 'la-angle-double-right', prefix: 'las', tags: ['arrow'] },
    { name: 'la-angle-double-up', prefix: 'las', tags: ['arrow'] },
    { name: 'la-angle-down', prefix: 'las', tags: ['arrow'] },
    { name: 'la-angle-left', prefix: 'las', tags: ['arrow'] },
    { name: 'la-angle-right', prefix: 'las', tags: ['arrow'] },
    { name: 'la-angle-up', prefix: 'las', tags: ['arrow'] },
    { name: 'la-angry', prefix: 'las', tags: ['emotions', 'people'] },
    { name: 'la-angrycreative', prefix: 'lab', tags: ['brand'] },
    { name: 'la-angular', prefix: 'lab', tags: ['brand'] },
    { name: 'la-ankh', prefix: 'las', tags: ['religion', 'social'] },
    { name: 'la-app-store', prefix: 'lab', tags: ['brand'] },
    { name: 'la-app-store-ios', prefix: 'lab', tags: ['brand'] },
    { name: 'la-apper', prefix: 'lab', tags: ['brand'] },
    { name: 'la-apple', prefix: 'lab', tags: ['brand'] },
    { name: 'la-apple-alt', prefix: 'las', tags: ['brand', 'food'] },
    { name: 'la-apple-pay', prefix: 'lab', tags: ['brand'] },
    { name: 'la-archive', prefix: 'las', tags: ['office'] },
    { name: 'la-archway', prefix: 'las', tags: ['buildings'] },
    { name: 'la-arrow-alt-circle-down', prefix: 'las', tags: ['arrow'] },
    { name: 'la-arrow-alt-circle-left', prefix: 'las', tags: ['arrow'] },
    { name: 'la-arrow-alt-circle-right', prefix: 'las', tags: ['arrow'] },
    { name: 'la-arrow-alt-circle-up', prefix: 'las', tags: ['arrow'] },
    { name: 'la-arrow-circle-down', prefix: 'las', tags: ['arrow'] },
    { name: 'la-arrow-circle-left', prefix: 'las', tags: ['arrow'] },
    { name: 'la-arrow-circle-right', prefix: 'las', tags: ['arrow'] },
    { name: 'la-arrow-circle-up', prefix: 'las', tags: ['arrow'] },
    { name: 'la-arrow-down', prefix: 'las', tags: ['arrow'] },
    { name: 'la-arrow-left', prefix: 'las', tags: ['arrow'] },
    { name: 'la-arrow-right', prefix: 'las', tags: ['arrow'] },
    { name: 'la-arrow-up', prefix: 'las', tags: ['arrow'] },
    { name: 'la-arrows-alt', prefix: 'las', tags: ['arrow'] },
    { name: 'la-arrows-alt-h', prefix: 'las', tags: ['arrow'] },
    { name: 'la-arrows-alt-v', prefix: 'las', tags: ['arrow'] },
    { name: 'la-artstation', prefix: 'lab', tags: ['brand'] },
    { name: 'la-assistive-listening-systems', prefix: 'las', tags: ['accessibility'] },
    { name: 'la-asterisk', prefix: 'las', tags: ['other'] },
    { name: 'la-asymmetrik', prefix: 'lab', tags: ['brand'] },
    { name: 'la-at', prefix: 'las', tags: ['web'] },
    { name: 'la-atlas', prefix: 'las', tags: ['travel'] },
    { name: 'la-atlassian', prefix: 'lab', tags: ['brand'] },
    { name: 'la-atom', prefix: 'las', tags: ['science'] },
    { name: 'la-audible', prefix: 'lab', tags: ['brand'] },
    { name: 'la-audio-description', prefix: 'las', tags: ['accessibility', 'media'] },
    { name: 'la-autoprefixer', prefix: 'lab', tags: ['brand'] },
    { name: 'la-avianex', prefix: 'lab', tags: ['brand'] },
    { name: 'la-aviato', prefix: 'lab', tags: ['brand'] },
    { name: 'la-award', prefix: 'las', tags: ['brand'] },
    { name: 'la-aws', prefix: 'lab', tags: ['brand'] },
    { name: 'la-baby', prefix: 'las', tags: ['family', 'people'] },
    { name: 'la-baby-carriage', prefix: 'las', tags: ['family', 'people'] },
    { name: 'la-backspace', prefix: 'las', tags: ['editor'] },
    { name: 'la-backward', prefix: 'las', tags: ['media'] },
    { name: 'la-bacon', prefix: 'las', tags: ['food'] },
    { name: 'la-balance-scale', prefix: 'las', tags: ['social'] },
    { name: 'la-balance-scale-left', prefix: 'las', tags: ['social'] },
    { name: 'la-balance-scale-right', prefix: 'las', tags: ['social'] },
    { name: 'la-ban', prefix: 'las', tags: ['social'] },
    { name: 'la-band-aid', prefix: 'las', tags: ['health'] },
    { name: 'la-bandcamp', prefix: 'lab', tags: ['brand'] },
    { name: 'la-barcode', prefix: 'las', tags: ['other', 'technology'] },
    { name: 'la-bars', prefix: 'las', tags: ['web'] },
    { name: 'la-baseball-ball', prefix: 'las', tags: ['sport'] },
    { name: 'la-basketball-ball', prefix: 'las', tags: ['sport'] },
    { name: 'la-bath', prefix: 'las', tags: ['home'] },
    { name: 'la-battery-empty', prefix: 'las', tags: ['technology'] },
    { name: 'la-battery-full', prefix: 'las', tags: ['technology'] },
    { name: 'la-battery-half', prefix: 'las', tags: ['technology'] },
    { name: 'la-battery-quarter', prefix: 'las', tags: ['technology'] },
    { name: 'la-battery-three-quarters', prefix: 'las', tags: ['technology'] },
    { name: 'la-battle-net', prefix: 'lab', tags: ['brand'] },
    { name: 'la-bed', prefix: 'las', tags: ['home'] },
    { name: 'la-beer', prefix: 'las', tags: ['food'] },
    { name: 'la-behance', prefix: 'lab', tags: ['brand'] },
    { name: 'la-behance-square', prefix: 'lab', tags: ['brand'] },
    { name: 'la-bell', prefix: 'las', tags: ['other'] },
    { name: 'la-bell-slash', prefix: 'las', tags: ['other'] },
    { name: 'la-bezier-curve', prefix: 'las', tags: ['science'] },
    { name: 'la-bible', prefix: 'las', tags: ['religion', 'social'] },
    { name: 'la-bicycle', prefix: 'las', tags: ['sport', 'travel'] },
    { name: 'la-biking', prefix: 'las', tags: ['sport', 'travel'] },
    { name: 'la-bimobject', prefix: 'lab', tags: ['brand'] },
    { name: 'la-binoculars', prefix: 'las', tags: ['other', 'travel'] },
    { name: 'la-biohazard', prefix: 'las', tags: ['other', 'science'] },
    { name: 'la-birthday-cake', prefix: 'las', tags: ['social'] },
    { name: 'la-bitbucket', prefix: 'lab', tags: ['brand'] },
    { name: 'la-bitcoin', prefix: 'lab', tags: ['brand'] },
    { name: 'la-bity', prefix: 'lab', tags: ['brand'] },
    { name: 'la-black-tie', prefix: 'lab', tags: ['brand'] },
    { name: 'la-blackberry', prefix: 'lab', tags: ['brand'] },
    { name: 'la-blender', prefix: 'las', tags: ['home', 'technology'] },
    { name: 'la-blender-phone', prefix: 'las', tags: ['home', 'technology'] },
    { name: 'la-blind', prefix: 'las', tags: ['accessibility'] },
    { name: 'la-blog', prefix: 'las', tags: ['web'] },
    { name: 'la-blogger', prefix: 'lab', tags: ['brand'] },
    { name: 'la-blogger-b', prefix: 'lab', tags: ['brand'] },
    { name: 'la-bluetooth', prefix: 'lab', tags: ['brand'] },
    { name: 'la-bluetooth-b', prefix: 'lab', tags: ['brand'] },
    { name: 'la-bold', prefix: 'las', tags: ['editor'] },
    { name: 'la-bolt', prefix: 'las', tags: ['editor'] },
    { name: 'la-bomb', prefix: 'las', tags: ['other'] },
    { name: 'la-bone', prefix: 'las', tags: ['food'] },
    { name: 'la-bong', prefix: 'las', tags: ['science'] },
    { name: 'la-book', prefix: 'las', tags: ['social'] },
    { name: 'la-book-dead', prefix: 'las', tags: ['social'] },
    { name: 'la-book-medical', prefix: 'las', tags: ['health', 'social'] },
    { name: 'la-book-open', prefix: 'las', tags: ['social'] },
    { name: 'la-book-reader', prefix: 'las', tags: ['social'] },
    { name: 'la-bookmark', prefix: 'las', tags: ['other', 'web'] },
    { name: 'la-bootstrap', prefix: 'lab', tags: ['brand'] },
    { name: 'la-border-all', prefix: 'las', tags: ['editor'] },
    { name: 'la-border-none', prefix: 'las', tags: ['editor'] },
    { name: 'la-border-style', prefix: 'las', tags: ['editor'] },
    { name: 'la-bowling-ball', prefix: 'las', tags: ['sport'] },
    { name: 'la-box', prefix: 'las', tags: ['other'] },
    { name: 'la-box-open', prefix: 'las', tags: ['other'] },
    { name: 'la-boxes', prefix: 'las', tags: ['other'] },
    { name: 'la-braille', prefix: 'las', tags: ['accessibility'] },
    { name: 'la-brain', prefix: 'las', tags: ['health', 'health', 'social'] },
    { name: 'la-bread-slice', prefix: 'las', tags: ['food'] },
    { name: 'la-briefcase', prefix: 'las', tags: ['office'] },
    { name: 'la-briefcase-medical', prefix: 'las', tags: ['health'] },
    { name: 'la-broadcast-tower', prefix: 'las', tags: ['media'] },
    { name: 'la-broom', prefix: 'las', tags: ['home', 'other'] },
    { name: 'la-brush', prefix: 'las', tags: ['social'] },
    { name: 'la-btc', prefix: 'lab', tags: ['brand'] },
    { name: 'la-buffer', prefix: 'lab', tags: ['brand'] },
    { name: 'la-bug', prefix: 'las', tags: ['nature', 'web'] },
    { name: 'la-building', prefix: 'las', tags: ['buildings'] },
    { name: 'la-bullhorn', prefix: 'las', tags: ['social', 'web'] },
    { name: 'la-bullseye', prefix: 'las', tags: ['other'] },
    { name: 'la-burn', prefix: 'las', tags: ['other', 'social', 'web'] },
    { name: 'la-buromobelexperte', prefix: 'lab', tags: ['brand'] },
    { name: 'la-bus', prefix: 'las', tags: ['social', 'technology', 'travel'] },
    { name: 'la-bus-alt', prefix: 'las', tags: ['social', 'technology', 'travel'] },
    { name: 'la-business-time', prefix: 'las', tags: ['office'] },
    { name: 'la-buy-n-large', prefix: 'lab', tags: ['brand'] },
    { name: 'la-buysellads', prefix: 'lab', tags: ['brand'] },
    { name: 'la-calculator', prefix: 'las', tags: ['science'] },
    { name: 'la-calendar', prefix: 'las', tags: ['office'] },
    { name: 'la-calendar-alt', prefix: 'las', tags: ['office'] },
    { name: 'la-calendar-check', prefix: 'las', tags: ['office'] },
    { name: 'la-calendar-day', prefix: 'las', tags: ['office'] },
    { name: 'la-calendar-minus', prefix: 'las', tags: ['office'] },
    { name: 'la-calendar-plus', prefix: 'las', tags: ['office'] },
    { name: 'la-calendar-times', prefix: 'las', tags: ['office'] },
    { name: 'la-calendar-week', prefix: 'las', tags: ['office'] },
    { name: 'la-camera', prefix: 'las', tags: ['technology', 'web'] },
    { name: 'la-camera-retro', prefix: 'las', tags: ['technology', 'web'] },
    { name: 'la-campground', prefix: 'las', tags: ['social', 'travel'] },
    { name: 'la-canadian-maple-leaf', prefix: 'lab', tags: ['brand'] },
    { name: 'la-candy-cane', prefix: 'las', tags: ['food'] },
    { name: 'la-cannabis', prefix: 'las', tags: ['food', 'social'] },
    { name: 'la-capsules', prefix: 'las', tags: ['health'] },
    { name: 'la-car', prefix: 'las', tags: ['travel'] },
    { name: 'la-car-alt', prefix: 'las', tags: ['travel'] },
    { name: 'la-car-battery', prefix: 'las', tags: ['travel'] },
    { name: 'la-car-crash', prefix: 'las', tags: ['travel'] },
    { name: 'la-car-side', prefix: 'las', tags: ['travel'] },
    { name: 'la-caret-down', prefix: 'las', tags: ['arrow'] },
    { name: 'la-caret-left', prefix: 'las', tags: ['arrow'] },
    { name: 'la-caret-right', prefix: 'las', tags: ['arrow'] },
    { name: 'la-caret-square-down', prefix: 'las', tags: ['arrow'] },
    { name: 'la-caret-square-left', prefix: 'las', tags: ['arrow'] },
    { name: 'la-caret-square-right', prefix: 'las', tags: ['arrow'] },
    { name: 'la-caret-square-up', prefix: 'las', tags: ['arrow'] },
    { name: 'la-caret-up', prefix: 'las', tags: ['arrow'] },
    { name: 'la-carrot', prefix: 'las', tags: ['food'] },
    { name: 'la-cart-arrow-down', prefix: 'las', tags: ['arrow'] },
    { name: 'la-cart-plus', prefix: 'las', tags: ['office'] },
    { name: 'la-cash-register', prefix: 'las', tags: ['money', 'technology'] },
    { name: 'la-cat', prefix: 'las', tags: ['nature'] },
    { name: 'la-cc-amazon-pay', prefix: 'lab', tags: ['brand'] },
    { name: 'la-cc-amex', prefix: 'lab', tags: ['brand'] },
    { name: 'la-cc-apple-pay', prefix: 'lab', tags: ['brand'] },
    { name: 'la-cc-diners-club', prefix: 'lab', tags: ['brand'] },
    { name: 'la-cc-discover', prefix: 'lab', tags: ['brand'] },
    { name: 'la-cc-jcb', prefix: 'lab', tags: ['brand'] },
    { name: 'la-cc-mastercard', prefix: 'lab', tags: ['brand'] },
    { name: 'la-cc-paypal', prefix: 'lab', tags: ['brand'] },
    { name: 'la-cc-stripe', prefix: 'lab', tags: ['brand'] },
    { name: 'la-cc-visa', prefix: 'lab', tags: ['brand'] },
    { name: 'la-centercode', prefix: 'lab', tags: ['brand'] },
    { name: 'la-centos', prefix: 'lab', tags: ['brand'] },
    { name: 'la-certificate', prefix: 'las', tags: ['social'] },
    { name: 'la-chair', prefix: 'las', tags: ['home'] },
    { name: 'la-chalkboard', prefix: 'las', tags: ['office'] },
    { name: 'la-chalkboard-teacher', prefix: 'las', tags: ['office', 'other', 'science'] },
    { name: 'la-charging-station', prefix: 'las', tags: ['travel'] },
    { name: 'la-chart-area', prefix: 'las', tags: ['office'] },
    { name: 'la-chart-bar', prefix: 'las', tags: ['office'] },
    { name: 'la-chart-line', prefix: 'las', tags: ['arrow', 'office'] },
    { name: 'la-chart-pie', prefix: 'las', tags: ['office'] },
    { name: 'la-check', prefix: 'las', tags: ['office', 'social', 'web'] },
    { name: 'la-check-circle', prefix: 'las', tags: ['office', 'social', 'web'] },
    { name: 'la-check-double', prefix: 'las', tags: ['office', 'social', 'web'] },
    { name: 'la-check-square', prefix: 'las', tags: ['office', 'social', 'web'] },
    { name: 'la-cheese', prefix: 'las', tags: ['food'] },
    { name: 'la-chess', prefix: 'las', tags: ['social'] },
    { name: 'la-chess-bishop', prefix: 'las', tags: ['social'] },
    { name: 'la-chess-board', prefix: 'las', tags: ['social'] },
    { name: 'la-chess-king', prefix: 'las', tags: ['social'] },
    { name: 'la-chess-knight', prefix: 'las', tags: ['social'] },
    { name: 'la-chess-pawn', prefix: 'las', tags: ['social'] },
    { name: 'la-chess-queen', prefix: 'las', tags: ['social'] },
    { name: 'la-chess-rook', prefix: 'las', tags: ['social'] },
    { name: 'la-chevron-circle-down', prefix: 'las', tags: ['arrow'] },
    { name: 'la-chevron-circle-left', prefix: 'las', tags: ['arrow'] },
    { name: 'la-chevron-circle-right', prefix: 'las', tags: ['arrow'] },
    { name: 'la-chevron-circle-up', prefix: 'las', tags: ['arrow'] },
    { name: 'la-chevron-down', prefix: 'las', tags: ['arrow'] },
    { name: 'la-chevron-left', prefix: 'las', tags: ['arrow'] },
    { name: 'la-chevron-right', prefix: 'las', tags: ['arrow'] },
    { name: 'la-chevron-up', prefix: 'las', tags: ['arrow'] },
    { name: 'la-child', prefix: 'las', tags: ['family', 'people'] },
    { name: 'la-chrome', prefix: 'lab', tags: ['brand'] },
    { name: 'la-chromecast', prefix: 'lab', tags: ['brand'] },
    { name: 'la-church', prefix: 'las', tags: ['buildings', 'social'] },
    { name: 'la-circle', prefix: 'las', tags: ['media', 'other'] },
    { name: 'la-circle-notch', prefix: 'las', tags: ['other'] },
    { name: 'la-city', prefix: 'las', tags: ['buildings'] },
    { name: 'la-clinic-medical', prefix: 'las', tags: ['buildings'] },
    { name: 'la-clipboard', prefix: 'las', tags: ['editor'] },
    { name: 'la-clipboard-check', prefix: 'las', tags: ['editor'] },
    { name: 'la-clipboard-list', prefix: 'las', tags: ['editor'] },
    { name: 'la-clock', prefix: 'las', tags: ['home', 'office', 'other'] },
    { name: 'la-clone', prefix: 'las', tags: ['editor'] },
    { name: 'la-closed-captioning', prefix: 'las', tags: ['accessibility', 'media'] },
    { name: 'la-cloud', prefix: 'las', tags: ['weather', 'web'] },
    { name: 'la-cloud-download-alt', prefix: 'las', tags: ['arrow'] },
    { name: 'la-cloud-meatball', prefix: 'las', tags: ['weather'] },
    { name: 'la-cloud-moon', prefix: 'las', tags: ['weather'] },
    { name: 'la-cloud-moon-rain', prefix: 'las', tags: ['weather'] },
    { name: 'la-cloud-rain', prefix: 'las', tags: ['weather'] },
    { name: 'la-cloud-showers-heavy', prefix: 'las', tags: ['weather'] },
    { name: 'la-cloud-sun', prefix: 'las', tags: ['weather'] },
    { name: 'la-cloud-sun-rain', prefix: 'las', tags: ['weather'] },
    { name: 'la-cloud-upload-alt', prefix: 'las', tags: ['arrow'] },
    { name: 'la-cloudscale', prefix: 'lab', tags: ['brand'] },
    { name: 'la-cloudsmith', prefix: 'lab', tags: ['brand'] },
    { name: 'la-cloudversify', prefix: 'lab', tags: ['brand'] },
    { name: 'la-cocktail', prefix: 'las', tags: ['food'] },
    { name: 'la-code', prefix: 'las', tags: ['technology', 'web'] },
    { name: 'la-code-branch', prefix: 'las', tags: ['technology', 'web'] },
    { name: 'la-codepen', prefix: 'lab', tags: ['brand'] },
    { name: 'la-codiepie', prefix: 'lab', tags: ['brand'] },
    { name: 'la-coffee', prefix: 'las', tags: ['food'] },
    { name: 'la-cog', prefix: 'las', tags: ['other', 'technology'] },
    { name: 'la-cogs', prefix: 'las', tags: ['other', 'technology'] },
    { name: 'la-coins', prefix: 'las', tags: ['money', 'social'] },
    { name: 'la-columns', prefix: 'las', tags: ['editor'] },
    { name: 'la-comment', prefix: 'las', tags: ['social', 'web'] },
    { name: 'la-comment-alt', prefix: 'las', tags: ['social', 'web'] },
    { name: 'la-comment-dollar', prefix: 'las', tags: ['social', 'web'] },
    { name: 'la-comment-dots', prefix: 'las', tags: ['social', 'web'] },
    { name: 'la-comment-medical', prefix: 'las', tags: ['social', 'web'] },
    { name: 'la-comment-slash', prefix: 'las', tags: ['social', 'web'] },
    { name: 'la-comments', prefix: 'las', tags: ['social', 'web'] },
    { name: 'la-comments-dollar', prefix: 'las', tags: ['social', 'web'] },
    { name: 'la-compact-disc', prefix: 'las', tags: ['technology'] },
    { name: 'la-compass', prefix: 'las', tags: ['social', 'travel', 'weather'] },
    { name: 'la-compress', prefix: 'las', tags: ['arrow', 'media'] },
    { name: 'la-compress-arrows-alt', prefix: 'las', tags: ['arrow', 'media'] },
    { name: 'la-concierge-bell', prefix: 'las', tags: ['social', 'travel'] },
    { name: 'la-confluence', prefix: 'lab', tags: ['brand'] },
    { name: 'la-connectdevelop', prefix: 'lab', tags: ['brand'] },
    { name: 'la-contao', prefix: 'lab', tags: ['brand'] },
    { name: 'la-cookie', prefix: 'las', tags: ['food'] },
    { name: 'la-cookie-bite', prefix: 'las', tags: ['food'] },
    { name: 'la-copy', prefix: 'las', tags: ['editor'] },
    { name: 'la-copyright', prefix: 'las', tags: ['social'] },
    { name: 'la-cotton-bureau', prefix: 'lab', tags: ['brand'] },
    { name: 'la-couch', prefix: 'las', tags: ['home'] },
    { name: 'la-cpanel', prefix: 'lab', tags: ['brand'] },
    { name: 'la-creative-commons', prefix: 'lab', tags: ['brand'] },
    { name: 'la-creative-commons-by', prefix: 'lab', tags: ['brand'] },
    { name: 'la-creative-commons-nc', prefix: 'lab', tags: ['brand'] },
    { name: 'la-creative-commons-nc-eu', prefix: 'lab', tags: ['brand'] },
    { name: 'la-creative-commons-nc-jp', prefix: 'lab', tags: ['brand'] },
    { name: 'la-creative-commons-nd', prefix: 'lab', tags: ['brand'] },
    { name: 'la-creative-commons-pd', prefix: 'lab', tags: ['brand'] },
    { name: 'la-creative-commons-pd-alt', prefix: 'lab', tags: ['brand'] },
    { name: 'la-creative-commons-remix', prefix: 'lab', tags: ['brand'] },
    { name: 'la-creative-commons-sa', prefix: 'lab', tags: ['brand'] },
    { name: 'la-creative-commons-sampling', prefix: 'lab', tags: ['brand'] },
    { name: 'la-creative-commons-sampling-plus', prefix: 'lab', tags: ['brand'] },
    { name: 'la-creative-commons-share', prefix: 'lab', tags: ['brand'] },
    { name: 'la-creative-commons-zero', prefix: 'lab', tags: ['brand'] },
    { name: 'la-credit-card', prefix: 'las', tags: ['money', 'social'] },
    { name: 'la-critical-role', prefix: 'lab', tags: ['brand'] },
    { name: 'la-crop', prefix: 'las', tags: ['editor'] },
    { name: 'la-crop-alt', prefix: 'las', tags: ['editor'] },
    { name: 'la-cross', prefix: 'las', tags: ['religion'] },
    { name: 'la-crosshairs', prefix: 'las', tags: ['other'] },
    { name: 'la-crow', prefix: 'las', tags: ['nature'] },
    { name: 'la-crown', prefix: 'las', tags: ['social'] },
    { name: 'la-crutch', prefix: 'las', tags: ['accessibility'] },
    { name: 'la-css3', prefix: 'lab', tags: ['brand', 'web'] },
    { name: 'la-css3-alt', prefix: 'lab', tags: ['brand', 'web'] },
    { name: 'la-cube', prefix: 'las', tags: ['other'] },
    { name: 'la-cubes', prefix: 'las', tags: ['other'] },
    { name: 'la-cut', prefix: 'las', tags: ['editor'] },
    { name: 'la-cuttlefish', prefix: 'lab', tags: ['brand'] },
    { name: 'la-d-and-d', prefix: 'lab', tags: ['brand'] },
    { name: 'la-d-and-d-beyond', prefix: 'lab', tags: ['brand'] },
    { name: 'la-dashcube', prefix: 'lab', tags: ['brand'] },
    { name: 'la-database', prefix: 'las', tags: ['technology'] },
    { name: 'la-deaf', prefix: 'las', tags: ['accessibility'] },
    { name: 'la-delicious', prefix: 'lab', tags: ['brand'] },
    { name: 'la-democrat', prefix: 'las', tags: ['other'] },
    { name: 'la-deploydog', prefix: 'lab', tags: ['brand'] },
    { name: 'la-deskpro', prefix: 'lab', tags: ['brand'] },
    { name: 'la-desktop', prefix: 'las', tags: ['technology'] },
    { name: 'la-dev', prefix: 'lab', tags: ['brand'] },
    { name: 'la-deviantart', prefix: 'lab', tags: ['brand'] },
    { name: 'la-dharmachakra', prefix: 'las', tags: ['brand'] },
    { name: 'la-dhl', prefix: 'lab', tags: ['brand'] },
    { name: 'la-diagnoses', prefix: 'las', tags: ['brand'] },
    { name: 'la-diaspora', prefix: 'lab', tags: ['brand'] },
    { name: 'la-dice', prefix: 'las', tags: ['other'] },
    { name: 'la-dice-d20', prefix: 'las', tags: ['other'] },
    { name: 'la-dice-d6', prefix: 'las', tags: ['other'] },
    { name: 'la-dice-five', prefix: 'las', tags: ['other'] },
    { name: 'la-dice-four', prefix: 'las', tags: ['other'] },
    { name: 'la-dice-one', prefix: 'las', tags: ['other'] },
    { name: 'la-dice-six', prefix: 'las', tags: ['other'] },
    { name: 'la-dice-three', prefix: 'las', tags: ['other'] },
    { name: 'la-dice-two', prefix: 'las', tags: ['other'] },
    { name: 'la-digg', prefix: 'lab', tags: ['brand'] },
    { name: 'la-digital-ocean', prefix: 'lab', tags: ['brand'] },
    { name: 'la-digital-tachograph', prefix: 'las', tags: ['technology'] },
    { name: 'la-directions', prefix: 'las', tags: ['social'] },
    { name: 'la-discord', prefix: 'lab', tags: ['brand'] },
    { name: 'la-discourse', prefix: 'lab', tags: ['brand'] },
    { name: 'la-divide', prefix: 'las', tags: ['science'] },
    { name: 'la-dizzy', prefix: 'las', tags: ['emotions'] },
    { name: 'la-dna', prefix: 'las', tags: ['science'] },
    { name: 'la-dochub', prefix: 'lab', tags: ['brand'] },
    { name: 'la-docker', prefix: 'lab', tags: ['brand'] },
    { name: 'la-dog', prefix: 'las', tags: ['nature'] },
    { name: 'la-dollar-sign', prefix: 'las', tags: ['money'] },
    { name: 'la-dolly', prefix: 'las', tags: ['travel'] },
    { name: 'la-dolly-flatbed', prefix: 'las', tags: ['other', 'travel'] },
    { name: 'la-donate', prefix: 'las', tags: ['social'] },
    { name: 'la-door-closed', prefix: 'las', tags: ['home', 'web'] },
    { name: 'la-door-open', prefix: 'las', tags: ['home', 'web'] },
    { name: 'la-dot-circle', prefix: 'las', tags: ['other'] },
    { name: 'la-dove', prefix: 'las', tags: ['nature'] },
    { name: 'la-download', prefix: 'las', tags: ['arrow'] },
    { name: 'la-draft2digital', prefix: 'lab', tags: ['brand'] },
    { name: 'la-drafting-compass', prefix: 'las', tags: ['science', 'travel'] },
    { name: 'la-dragon', prefix: 'las', tags: ['nature'] },
    { name: 'la-draw-polygon', prefix: 'las', tags: ['editor'] },
    { name: 'la-dribbble', prefix: 'lab', tags: ['brand'] },
    { name: 'la-dribbble-square', prefix: 'lab', tags: ['brand'] },
    { name: 'la-dropbox', prefix: 'lab', tags: ['brand'] },
    { name: 'la-drum', prefix: 'las', tags: ['social'] },
    { name: 'la-drum-steelpan', prefix: 'las', tags: ['social'] },
    { name: 'la-drumstick-bite', prefix: 'las', tags: ['social'] },
    { name: 'la-drupal', prefix: 'lab', tags: ['brand'] },
    { name: 'la-dumbbell', prefix: 'las', tags: ['sport'] },
    { name: 'la-dumpster', prefix: 'las', tags: ['other'] },
    { name: 'la-dumpster-fire', prefix: 'las', tags: ['other'] },
    { name: 'la-dungeon', prefix: 'las', tags: ['other'] },
    { name: 'la-dyalog', prefix: 'lab', tags: ['brand'] },
    { name: 'la-earlybirds', prefix: 'lab', tags: ['brand'] },
    { name: 'la-ebay', prefix: 'lab', tags: ['brand'] },
    { name: 'la-edge', prefix: 'lab', tags: ['brand'] },
    { name: 'la-edit', prefix: 'las', tags: ['editor'] },
    { name: 'la-egg', prefix: 'las', tags: ['nature'] },
    { name: 'la-eject', prefix: 'las', tags: ['media'] },
    { name: 'la-elementor', prefix: 'lab', tags: ['brand'] },
    { name: 'la-ellipsis-h', prefix: 'las', tags: ['science'] },
    { name: 'la-ellipsis-v', prefix: 'las', tags: ['science'] },
    { name: 'la-ello', prefix: 'lab', tags: ['brand'] },
    { name: 'la-ember', prefix: 'lab', tags: ['brand'] },
    { name: 'la-empire', prefix: 'lab', tags: ['brand'] },
    { name: 'la-envelope', prefix: 'las', tags: ['social', 'web'] },
    { name: 'la-envelope-open', prefix: 'las', tags: ['social', 'web'] },
    { name: 'la-envelope-open-text', prefix: 'las', tags: ['social', 'web'] },
    { name: 'la-envelope-square', prefix: 'las', tags: ['social', 'web'] },
    { name: 'la-envira', prefix: 'lab', tags: ['brand'] },
    { name: 'la-equals', prefix: 'las', tags: ['science'] },
    { name: 'la-eraser', prefix: 'las', tags: ['editor'] },
    { name: 'la-erlang', prefix: 'lab', tags: ['brand'] },
    { name: 'la-ethereum', prefix: 'lab', tags: ['brand'] },
    { name: 'la-ethernet', prefix: 'las', tags: ['technology', 'web'] },
    { name: 'la-etsy', prefix: 'lab', tags: ['brand'] },
    { name: 'la-euro-sign', prefix: 'las', tags: ['money'] },
    { name: 'la-evernote', prefix: 'lab', tags: ['brand'] },
    { name: 'la-exchange-alt', prefix: 'las', tags: ['arrow'] },
    { name: 'la-exclamation', prefix: 'las', tags: ['social', 'web'] },
    { name: 'la-exclamation-circle', prefix: 'las', tags: ['social', 'web'] },
    { name: 'la-exclamation-triangle', prefix: 'las', tags: ['social', 'web'] },
    { name: 'la-expand', prefix: 'las', tags: ['arrow', 'media'] },
    { name: 'la-expand-arrows-alt', prefix: 'las', tags: ['media'] },
    { name: 'la-expeditedssl', prefix: 'lab', tags: ['brand'] },
    { name: 'la-external-link-alt', prefix: 'las', tags: ['arrow'] },
    { name: 'la-external-link-square-alt', prefix: 'las', tags: ['arrow'] },
    { name: 'la-eye', prefix: 'las', tags: ['health', 'people', 'social'] },
    { name: 'la-eye-dropper', prefix: 'las', tags: ['health'] },
    { name: 'la-eye-slash', prefix: 'las', tags: ['health', 'social'] },
    { name: 'la-facebook', prefix: 'lab', tags: ['brand'] },
    { name: 'la-facebook-f', prefix: 'lab', tags: ['brand'] },
    { name: 'la-facebook-messenger', prefix: 'lab', tags: ['brand'] },
    { name: 'la-facebook-square', prefix: 'lab', tags: ['brand'] },
    { name: 'la-fan', prefix: 'las', tags: ['technology'] },
    { name: 'la-fantasy-flight-games', prefix: 'lab', tags: ['brand'] },
    { name: 'la-fast-backward', prefix: 'las', tags: ['media'] },
    { name: 'la-fast-forward', prefix: 'las', tags: ['media'] },
    { name: 'la-fax', prefix: 'las', tags: ['office', 'technology'] },
    { name: 'la-feather', prefix: 'las', tags: ['nature'] },
    { name: 'la-feather-alt', prefix: 'las', tags: ['nature'] },
    { name: 'la-fedex', prefix: 'lab', tags: ['brand'] },
    { name: 'la-fedora', prefix: 'lab', tags: ['brand'] },
    { name: 'la-female', prefix: 'las', tags: ['people'] },
    { name: 'la-fighter-jet', prefix: 'las', tags: ['technology'] },
    { name: 'la-figma', prefix: 'lab', tags: ['brand'] },
    { name: 'la-file', prefix: 'las', tags: ['computer', 'editor'] },
    { name: 'la-file-alt', prefix: 'las', tags: ['editor'] },
    { name: 'la-file-archive', prefix: 'las', tags: ['computer'] },
    { name: 'la-file-audio', prefix: 'las', tags: ['media'] },
    { name: 'la-file-code', prefix: 'las', tags: ['computer', 'editor'] },
    { name: 'la-file-contract', prefix: 'las', tags: ['computer'] },
    { name: 'la-file-csv', prefix: 'las', tags: ['computer'] },
    { name: 'la-file-download', prefix: 'las', tags: ['computer', 'web'] },
    { name: 'la-file-excel', prefix: 'las', tags: ['computer', 'office'] },
    { name: 'la-file-export', prefix: 'las', tags: ['computer'] },
    { name: 'la-file-image', prefix: 'las', tags: ['computer', 'media'] },
    { name: 'la-file-import', prefix: 'las', tags: ['computer'] },
    { name: 'la-file-invoice', prefix: 'las', tags: ['computer', 'office'] },
    { name: 'la-file-invoice-dollar', prefix: 'las', tags: ['computer', 'office'] },
    { name: 'la-file-medical', prefix: 'las', tags: ['computer', 'health'] },
    { name: 'la-file-medical-alt', prefix: 'las', tags: ['computer', 'health'] },
    { name: 'la-file-pdf', prefix: 'las', tags: ['computer', 'office'] },
    { name: 'la-file-powerpoint', prefix: 'las', tags: ['computer', 'office'] },
    { name: 'la-file-prescription', prefix: 'las', tags: ['computer', 'health'] },
    { name: 'la-file-signature', prefix: 'las', tags: ['computer'] },
    { name: 'la-file-upload', prefix: 'las', tags: ['computer', 'web'] },
    { name: 'la-file-video', prefix: 'las', tags: ['computer', 'media'] },
    { name: 'la-file-word', prefix: 'las', tags: ['computer', 'office'] },
    { name: 'la-fill', prefix: 'las', tags: ['editor'] },
    { name: 'la-fill-drip', prefix: 'las', tags: ['editor'] },
    { name: 'la-film', prefix: 'las', tags: ['media'] },
    { name: 'la-filter', prefix: 'las', tags: ['web'] },
    { name: 'la-fingerprint', prefix: 'las', tags: ['computer', 'technology'] },
    { name: 'la-fire', prefix: 'las', tags: ['nature', 'social', 'travel', 'web'] },
    { name: 'la-fire-alt', prefix: 'las', tags: ['nature', 'social', 'travel', 'web'] },
    { name: 'la-fire-extinguisher', prefix: 'las', tags: ['social', 'technology'] },
    { name: 'la-firefox', prefix: 'lab', tags: ['brand'] },
    { name: 'la-first-aid', prefix: 'las', tags: ['health'] },
    { name: 'la-first-order', prefix: 'lab', tags: ['brand'] },
    { name: 'la-first-order-alt', prefix: 'lab', tags: ['brand'] },
    { name: 'la-firstdraft', prefix: 'lab', tags: ['brand'] },
    { name: 'la-fish', prefix: 'las', tags: ['nature'] },
    { name: 'la-fist-raised', prefix: 'las', tags: ['social'] },
    { name: 'la-flag', prefix: 'las', tags: ['social'] },
    { name: 'la-flag-checkered', prefix: 'las', tags: ['social'] },
    { name: 'la-flag-usa', prefix: 'las', tags: ['social'] },
    { name: 'la-flask', prefix: 'las', tags: ['science'] },
    { name: 'la-flickr', prefix: 'lab', tags: ['brand'] },
    { name: 'la-flipboard', prefix: 'lab', tags: ['brand'] },
    { name: 'la-flushed', prefix: 'las', tags: ['emotions'] },
    { name: 'la-fly', prefix: 'lab', tags: ['brand'] },
    { name: 'la-folder', prefix: 'las', tags: ['computer', 'office', 'web'] },
    { name: 'la-folder-minus', prefix: 'las', tags: ['computer', 'office', 'web'] },
    { name: 'la-folder-open', prefix: 'las', tags: ['computer', 'office', 'web'] },
    { name: 'la-folder-plus', prefix: 'las', tags: ['computer', 'office', 'web'] },
    { name: 'la-font', prefix: 'las', tags: ['editor'] },
    { name: 'la-font-awesome', prefix: 'lab', tags: ['brand'] },
    { name: 'la-font-awesome-alt', prefix: 'lab', tags: ['brand'] },
    { name: 'la-font-awesome-flag', prefix: 'lab', tags: ['brand'] },
    { name: 'la-fonticons', prefix: 'lab', tags: ['brand'] },
    { name: 'la-fonticons-fi', prefix: 'lab', tags: ['brand'] },
    { name: 'la-football-ball', prefix: 'las', tags: ['sport'] },
    { name: 'la-fort-awesome', prefix: 'lab', tags: ['brand'] },
    { name: 'la-fort-awesome-alt', prefix: 'lab', tags: ['brand'] },
    { name: 'la-forumbee', prefix: 'lab', tags: ['brand'] },
    { name: 'la-forward', prefix: 'las', tags: ['media'] },
    { name: 'la-foursquare', prefix: 'lab', tags: ['brand'] },
    { name: 'la-free-code-camp', prefix: 'lab', tags: ['brand'] },
    { name: 'la-freebsd', prefix: 'lab', tags: ['brand'] },
    { name: 'la-frog', prefix: 'las', tags: ['nature'] },
    { name: 'la-frown', prefix: 'las', tags: ['emotions'] },
    { name: 'la-frown-open', prefix: 'las', tags: ['emotions'] },
    { name: 'la-fulcrum', prefix: 'lab', tags: ['brand'] },
    { name: 'la-funnel-dollar', prefix: 'las', tags: ['money'] },
    { name: 'la-futbol', prefix: 'las', tags: ['sport'] },
    { name: 'la-galactic-republic', prefix: 'lab', tags: ['brand'] },
    { name: 'la-galactic-senate', prefix: 'lab', tags: ['brand'] },
    { name: 'la-gamepad', prefix: 'las', tags: ['social'] },
    { name: 'la-gas-pump', prefix: 'las', tags: ['travel'] },
    { name: 'la-gavel', prefix: 'las', tags: ['social'] },
    { name: 'la-gem', prefix: 'las', tags: ['other'] },
    { name: 'la-genderless', prefix: 'las', tags: ['other'] },
    { name: 'la-get-pocket', prefix: 'lab', tags: ['brand'] },
    { name: 'la-gg', prefix: 'lab', tags: ['brand'] },
    { name: 'la-gg-circle', prefix: 'lab', tags: ['brand'] },
    { name: 'la-ghost', prefix: 'las', tags: ['other'] },
    { name: 'la-gift', prefix: 'las', tags: ['other', 'social'] },
    { name: 'la-gifts', prefix: 'las', tags: ['other', 'social'] },
    { name: 'la-git', prefix: 'lab', tags: ['brand'] },
    { name: 'la-git-alt', prefix: 'lab', tags: ['brand'] },
    { name: 'la-git-square', prefix: 'lab', tags: ['brand'] },
    { name: 'la-github', prefix: 'lab', tags: ['brand'] },
    { name: 'la-github-alt', prefix: 'lab', tags: ['brand'] },
    { name: 'la-github-square', prefix: 'lab', tags: ['brand'] },
    { name: 'la-gitkraken', prefix: 'lab', tags: ['brand'] },
    { name: 'la-gitlab', prefix: 'lab', tags: ['brand'] },
    { name: 'la-gitter', prefix: 'lab', tags: ['brand'] },
    { name: 'la-glass-cheers', prefix: 'las', tags: ['food', 'social'] },
    { name: 'la-glass-martini', prefix: 'las', tags: ['food', 'social'] },
    { name: 'la-glass-martini-alt', prefix: 'las', tags: ['food', 'social'] },
    { name: 'la-glass-whiskey', prefix: 'las', tags: ['food', 'social'] },
    { name: 'la-glasses', prefix: 'las', tags: ['food', 'social'] },
    { name: 'la-glide', prefix: 'lab', tags: ['brand'] },
    { name: 'la-glide-g', prefix: 'lab', tags: ['brand'] },
    { name: 'la-globe', prefix: 'las', tags: ['social', 'travel'] },
    { name: 'la-globe-africa', prefix: 'las', tags: ['social', 'travel'] },
    { name: 'la-globe-americas', prefix: 'las', tags: ['social', 'travel'] },
    { name: 'la-globe-asia', prefix: 'las', tags: ['social', 'travel'] },
    { name: 'la-globe-europe', prefix: 'las', tags: ['social', 'travel'] },
    { name: 'la-gofore', prefix: 'lab', tags: ['brand'] },
    { name: 'la-golf-ball', prefix: 'las', tags: ['sport'] },
    { name: 'la-goodreads', prefix: 'lab', tags: ['brand'] },
    { name: 'la-goodreads-g', prefix: 'lab', tags: ['brand'] },
    { name: 'la-google', prefix: 'lab', tags: ['brand'] },
    { name: 'la-google-drive', prefix: 'lab', tags: ['brand'] },
    { name: 'la-google-play', prefix: 'lab', tags: ['brand'] },
    { name: 'la-google-plus', prefix: 'lab', tags: ['brand'] },
    { name: 'la-google-plus-g', prefix: 'lab', tags: ['brand'] },
    { name: 'la-google-plus-square', prefix: 'lab', tags: ['brand'] },
    { name: 'la-google-wallet', prefix: 'lab', tags: ['brand'] },
    { name: 'la-gopuram', prefix: 'las', tags: ['buildings'] },
    { name: 'la-graduation-cap', prefix: 'las', tags: ['science', 'social'] },
    { name: 'la-gratipay', prefix: 'lab', tags: ['brand'] },
    { name: 'la-grav', prefix: 'lab', tags: ['brand'] },
    { name: 'la-greater-than', prefix: 'las', tags: ['science'] },
    { name: 'la-greater-than-equal', prefix: 'las', tags: ['science'] },
    { name: 'la-grimace', prefix: 'las', tags: ['emotions'] },
    { name: 'la-grin', prefix: 'las', tags: ['emotions'] },
    { name: 'la-grin-alt', prefix: 'las', tags: ['emotions'] },
    { name: 'la-grin-beam', prefix: 'las', tags: ['emotions'] },
    { name: 'la-grin-beam-sweat', prefix: 'las', tags: ['emotions'] },
    { name: 'la-grin-hearts', prefix: 'las', tags: ['emotions'] },
    { name: 'la-grin-squint', prefix: 'las', tags: ['emotions'] },
    { name: 'la-grin-squint-tears', prefix: 'las', tags: ['emotions'] },
    { name: 'la-grin-stars', prefix: 'las', tags: ['emotions'] },
    { name: 'la-grin-tears', prefix: 'las', tags: ['emotions'] },
    { name: 'la-grin-tongue', prefix: 'las', tags: ['emotions'] },
    { name: 'la-grin-tongue-squint', prefix: 'las', tags: ['emotions'] },
    { name: 'la-grin-tongue-wink', prefix: 'las', tags: ['emotions'] },
    { name: 'la-grin-wink', prefix: 'las', tags: ['emotions'] },
    { name: 'la-grip-horizontal', prefix: 'las', tags: ['emotions'] },
    { name: 'la-grip-lines', prefix: 'las', tags: ['emotions'] },
    { name: 'la-grip-lines-vertical', prefix: 'las', tags: ['emotions'] },
    { name: 'la-grip-vertical', prefix: 'las', tags: ['emotions'] },
    { name: 'la-gripfire', prefix: 'lab', tags: ['brand'] },
    { name: 'la-grunt', prefix: 'lab', tags: ['brand'] },
    { name: 'la-guitar', prefix: 'las', tags: ['social', 'travel'] },
    { name: 'la-gulp', prefix: 'lab', tags: ['brand'] },
    { name: 'la-h-square', prefix: 'las', tags: ['editor'] },
    { name: 'la-hacker-news', prefix: 'lab', tags: ['brand'] },
    { name: 'la-hacker-news-square', prefix: 'lab', tags: ['brand'] },
    { name: 'la-hackerrank', prefix: 'lab', tags: ['brand'] },
    { name: 'la-hamburger', prefix: 'las', tags: ['food'] },
    { name: 'la-hammer', prefix: 'las', tags: ['other'] },
    { name: 'la-hamsa', prefix: 'las', tags: ['other', 'social'] },
    { name: 'la-hand-holding', prefix: 'las', tags: ['social'] },
    { name: 'la-hand-holding-heart', prefix: 'las', tags: ['social'] },
    { name: 'la-hand-holding-usd', prefix: 'las', tags: ['social'] },
    { name: 'la-hand-lizard', prefix: 'las', tags: ['social'] },
    { name: 'la-hand-middle-finger', prefix: 'las', tags: ['social'] },
    { name: 'la-hand-paper', prefix: 'las', tags: ['social'] },
    { name: 'la-hand-peace', prefix: 'las', tags: ['social'] },
    { name: 'la-hand-point-down', prefix: 'las', tags: ['arrow'] },
    { name: 'la-hand-point-down', prefix: 'lar', tags: ['arrow'] },
    { name: 'la-hand-point-left', prefix: 'las', tags: ['arrow'] },
    { name: 'la-hand-point-left', prefix: 'lar', tags: ['arrow'] },
    { name: 'la-hand-point-right', prefix: 'las', tags: ['arrow'] },
    { name: 'la-hand-point-right', prefix: 'lar', tags: ['arrow'] },
    { name: 'la-hand-point-up', prefix: 'las', tags: ['arrow'] },
    { name: 'la-hand-point-up', prefix: 'lar', tags: ['arrow'] },
    { name: 'la-hand-pointer', prefix: 'las', tags: ['arrow'] },
    { name: 'la-hand-pointer', prefix: 'lar', tags: ['arrow'] },
    { name: 'la-hand-rock', prefix: 'las', tags: ['social'] },
    { name: 'la-hand-scissors', prefix: 'las', tags: ['social'] },
    { name: 'la-hand-spock', prefix: 'las', tags: ['social'] },
    { name: 'la-hands', prefix: 'las', tags: ['social'] },
    { name: 'la-hands-helping', prefix: 'las', tags: ['social'] },
    { name: 'la-handshake', prefix: 'las', tags: ['social'] },
    { name: 'la-hanukiah', prefix: 'las', tags: ['social'] },
    { name: 'la-hard-hat', prefix: 'las', tags: ['social'] },
    { name: 'la-hashtag', prefix: 'las', tags: ['web'] },
    { name: 'la-hat-cowboy', prefix: 'las', tags: ['other', 'social'] },
    { name: 'la-hat-cowboy-side', prefix: 'las', tags: ['other', 'social'] },
    { name: 'la-hat-wizard', prefix: 'las', tags: ['other', 'social'] },
    { name: 'la-haykal', prefix: 'las', tags: ['other'] },
    { name: 'la-hdd', prefix: 'las', tags: ['computer'] },
    { name: 'la-heading', prefix: 'las', tags: ['editor'] },
    { name: 'la-headphones', prefix: 'las', tags: ['media'] },
    { name: 'la-headphones-alt', prefix: 'las', tags: ['media'] },
    { name: 'la-headset', prefix: 'las', tags: ['computer', 'office', 'technology'] },
    { name: 'la-heart', prefix: 'las', tags: ['social'] },
    { name: 'la-heart-broken', prefix: 'las', tags: ['social'] },
    { name: 'la-heartbeat', prefix: 'las', tags: ['health'] },
    { name: 'la-helicopter', prefix: 'las', tags: ['technology'] },
    { name: 'la-highlighter', prefix: 'las', tags: ['art', 'social'] },
    { name: 'la-hiking', prefix: 'las', tags: ['travel'] },
    { name: 'la-hippo', prefix: 'las', tags: ['nature'] },
    { name: 'la-hips', prefix: 'lab', tags: ['brand'] },
    { name: 'la-hire-a-helper', prefix: 'lab', tags: ['brand'] },
    { name: 'la-history', prefix: 'las', tags: ['arrow'] },
    { name: 'la-hockey-puck', prefix: 'las', tags: ['sport'] },
    { name: 'la-holly-berry', prefix: 'las', tags: ['social'] },
    { name: 'la-home', prefix: 'las', tags: ['buildings', 'web'] },
    { name: 'la-hooli', prefix: 'lab', tags: ['brand'] },
    { name: 'la-hornbill', prefix: 'lab', tags: ['brand'] },
    { name: 'la-horse', prefix: 'las', tags: ['nature'] },
    { name: 'la-horse-head', prefix: 'las', tags: ['nature'] },
    { name: 'la-hospital', prefix: 'las', tags: ['health'] },
    { name: 'la-hospital-alt', prefix: 'las', tags: ['health'] },
    { name: 'la-hospital-symbol', prefix: 'las', tags: ['health'] },
    { name: 'la-hot-tub', prefix: 'las', tags: ['home'] },
    { name: 'la-hotdog', prefix: 'las', tags: ['food'] },
    { name: 'la-hotel', prefix: 'las', tags: ['buildings'] },
    { name: 'la-hotjar', prefix: 'lab', tags: ['brand'] },
    { name: 'la-hourglass', prefix: 'las', tags: ['other', 'social'] },
    { name: 'la-hourglass-end', prefix: 'las', tags: ['other', 'social'] },
    { name: 'la-hourglass-half', prefix: 'las', tags: ['other', 'social'] },
    { name: 'la-hourglass-start', prefix: 'las', tags: ['other', 'social'] },
    { name: 'la-house-damage', prefix: 'las', tags: ['buildings'] },
    { name: 'la-houzz', prefix: 'lab', tags: ['brand'] },
    { name: 'la-hryvnia', prefix: 'las', tags: ['money'] },
    { name: 'la-html5', prefix: 'lab', tags: ['brand'] },
    { name: 'la-hubspot', prefix: 'lab', tags: ['brand'] },
    { name: 'la-i-cursor', prefix: 'las', tags: ['computer'] },
    { name: 'la-ice-cream', prefix: 'las', tags: ['food'] },
    { name: 'la-icicles', prefix: 'las', tags: ['other', 'travel'] },
    { name: 'la-icons', prefix: 'las', tags: ['computer', 'web'] },
    { name: 'la-id-badge', prefix: 'las', tags: ['social'] },
    { name: 'la-id-card', prefix: 'las', tags: ['social'] },
    { name: 'la-id-card-alt', prefix: 'las', tags: ['social'] },
    { name: 'la-igloo', prefix: 'las', tags: ['buildings', 'travel'] },
    { name: 'la-image', prefix: 'las', tags: ['computer', 'web'] },
    { name: 'la-images', prefix: 'las', tags: ['computer', 'web'] },
    { name: 'la-imdb', prefix: 'lab', tags: ['brand'] },
    { name: 'la-inbox', prefix: 'las', tags: ['other', 'web'] },
    { name: 'la-indent', prefix: 'las', tags: ['editor'] },
    { name: 'la-industry', prefix: 'las', tags: ['buildings', 'technology'] },
    { name: 'la-infinity', prefix: 'las', tags: ['science'] },
    { name: 'la-info', prefix: 'las', tags: ['office', 'social', 'web'] },
    { name: 'la-info-circle', prefix: 'las', tags: ['office', 'social', 'web'] },
    { name: 'la-instagram', prefix: 'lab', tags: ['brand'] },
    { name: 'la-intercom', prefix: 'lab', tags: ['brand'] },
    { name: 'la-internet-explorer', prefix: 'lab', tags: ['brand'] },
    { name: 'la-invision', prefix: 'lab', tags: ['brand'] },
    { name: 'la-ioxhost', prefix: 'lab', tags: ['brand'] },
    { name: 'la-italic', prefix: 'las', tags: ['brand'] },
    { name: 'la-itch-io', prefix: 'lab', tags: ['brand'] },
    { name: 'la-itunes', prefix: 'lab', tags: ['brand'] },
    { name: 'la-itunes-note', prefix: 'lab', tags: ['brand'] },
    { name: 'la-java', prefix: 'lab', tags: ['brand'] },
    { name: 'la-jedi', prefix: 'las', tags: ['other', 'social'] },
    { name: 'la-jedi-order', prefix: 'lab', tags: ['brand'] },
    { name: 'la-jenkins', prefix: 'lab', tags: ['brand'] },
    { name: 'la-jira', prefix: 'lab', tags: ['brand'] },
    { name: 'la-joget', prefix: 'lab', tags: ['brand'] },
    { name: 'la-joint', prefix: 'las', tags: ['social'] },
    { name: 'la-joomla', prefix: 'lab', tags: ['brand'] },
    { name: 'la-journal-whills', prefix: 'las', tags: ['social'] },
    { name: 'la-js', prefix: 'lab', tags: ['brand'] },
    { name: 'la-js-square', prefix: 'lab', tags: ['brand'] },
    { name: 'la-jsfiddle', prefix: 'lab', tags: ['brand'] },
    { name: 'la-kaaba', prefix: 'las', tags: ['social'] },
    { name: 'la-kaggle', prefix: 'lab', tags: ['brand'] },
    { name: 'la-key', prefix: 'las', tags: ['computer', 'social', 'web'] },
    { name: 'la-keybase', prefix: 'lab', tags: ['brand'] },
    { name: 'la-keyboard', prefix: 'las', tags: ['computer'] },
    { name: 'la-keycdn', prefix: 'lab', tags: ['brand'] },
    { name: 'la-khanda', prefix: 'las', tags: ['social'] },
    { name: 'la-kickstarter', prefix: 'lab', tags: ['brand'] },
    { name: 'la-kickstarter-k', prefix: 'lab', tags: ['brand'] },
    { name: 'la-kiss', prefix: 'las', tags: ['emotions', 'family'] },
    { name: 'la-kiss-beam', prefix: 'las', tags: ['emotions', 'family'] },
    { name: 'la-kiss-wink-heart', prefix: 'las', tags: ['emotions', 'family'] },
    { name: 'la-kiwi-bird', prefix: 'las', tags: ['nature'] },
    { name: 'la-korvue', prefix: 'lab', tags: ['brand'] },
    { name: 'la-landmark', prefix: 'las', tags: ['buildings'] },
    { name: 'la-language', prefix: 'las', tags: ['social', 'travel', 'web'] },
    { name: 'la-laptop', prefix: 'las', tags: ['computer'] },
    { name: 'la-laptop-code', prefix: 'las', tags: ['computer'] },
    { name: 'la-laptop-medical', prefix: 'las', tags: ['computer', 'health'] },
    { name: 'la-laravel', prefix: 'lab', tags: ['brand'] },
    { name: 'la-lastfm', prefix: 'lab', tags: ['brand'] },
    { name: 'la-lastfm-square', prefix: 'lab', tags: ['brand'] },
    { name: 'la-laugh', prefix: 'las', tags: ['emotions'] },
    { name: 'la-laugh-beam', prefix: 'las', tags: ['emotions'] },
    { name: 'la-laugh-squint', prefix: 'las', tags: ['emotions'] },
    { name: 'la-laugh-wink', prefix: 'las', tags: ['emotions'] },
    { name: 'la-layer-group', prefix: 'las', tags: ['editor'] },
    { name: 'la-leaf', prefix: 'las', tags: ['nature'] },
    { name: 'la-leanpub', prefix: 'lab', tags: ['brand'] },
    { name: 'la-lemon', prefix: 'las', tags: ['brand'] },
    { name: 'la-less', prefix: 'lab', tags: ['brand'] },
    { name: 'la-less-than', prefix: 'las', tags: ['science'] },
    { name: 'la-less-than-equal', prefix: 'las', tags: ['science'] },
    { name: 'la-level-down-alt', prefix: 'las', tags: ['arrow'] },
    { name: 'la-level-up-alt', prefix: 'las', tags: ['arrow'] },
    { name: 'la-life-ring', prefix: 'las', tags: ['social'] },
    { name: 'la-lightbulb', prefix: 'las', tags: ['art', 'technology'] },
    { name: 'la-line', prefix: 'lab', tags: ['brand'] },
    { name: 'la-link', prefix: 'las', tags: ['editor', 'web'] },
    { name: 'la-linkedin', prefix: 'lab', tags: ['brand'] },
    { name: 'la-linkedin-in', prefix: 'lab', tags: ['brand'] },
    { name: 'la-linode', prefix: 'lab', tags: ['brand'] },
    { name: 'la-linux', prefix: 'lab', tags: ['brand'] },
    { name: 'la-lira-sign', prefix: 'las', tags: ['money'] },
    { name: 'la-list', prefix: 'las', tags: ['editor'] },
    { name: 'la-list-alt', prefix: 'las', tags: ['editor'] },
    { name: 'la-list-ol', prefix: 'las', tags: ['editor'] },
    { name: 'la-list-ul', prefix: 'las', tags: ['editor'] },
    { name: 'la-location-arrow', prefix: 'las', tags: ['arrow'] },
    { name: 'la-lock', prefix: 'las', tags: ['computer', 'social', 'web'] },
    { name: 'la-lock-open', prefix: 'las', tags: ['computer', 'social', 'web'] },
    { name: 'la-long-arrow-alt-down', prefix: 'las', tags: ['arrow'] },
    { name: 'la-long-arrow-alt-left', prefix: 'las', tags: ['arrow'] },
    { name: 'la-long-arrow-alt-right', prefix: 'las', tags: ['arrow'] },
    { name: 'la-long-arrow-alt-up', prefix: 'las', tags: ['arrow'] },
    { name: 'la-low-vision', prefix: 'las', tags: ['accessibility'] },
    { name: 'la-luggage-cart', prefix: 'las', tags: ['technology', 'travel'] },
    { name: 'la-lyft', prefix: 'lab', tags: ['brand'] },
    { name: 'la-magento', prefix: 'lab', tags: ['brand'] },
    { name: 'la-magic', prefix: 'las', tags: ['social'] },
    { name: 'la-magnet', prefix: 'las', tags: ['science', 'technology'] },
    { name: 'la-mail-bulk', prefix: 'las', tags: ['office', 'social'] },
    { name: 'la-mailchimp', prefix: 'lab', tags: ['brand'] },
    { name: 'la-male', prefix: 'las', tags: ['people'] },
    { name: 'la-mandalorian', prefix: 'lab', tags: ['brand'] },
    { name: 'la-map', prefix: 'las', tags: ['travel'] },
    { name: 'la-map-marked', prefix: 'las', tags: ['travel'] },
    { name: 'la-map-marked-alt', prefix: 'las', tags: ['travel'] },
    { name: 'la-map-marker', prefix: 'las', tags: ['travel'] },
    { name: 'la-map-marker-alt', prefix: 'las', tags: ['travel'] },
    { name: 'la-map-pin', prefix: 'las', tags: ['travel'] },
    { name: 'la-map-signs', prefix: 'las', tags: ['travel'] },
    { name: 'la-markdown', prefix: 'lab', tags: ['brand', 'editor'] },
    { name: 'la-marker', prefix: 'las', tags: ['editor', 'office'] },
    { name: 'la-mars', prefix: 'las', tags: ['social'] },
    { name: 'la-mars-double', prefix: 'las', tags: ['social'] },
    { name: 'la-mars-stroke', prefix: 'las', tags: ['social'] },
    { name: 'la-mars-stroke-h', prefix: 'las', tags: ['social'] },
    { name: 'la-mars-stroke-v', prefix: 'las', tags: ['social'] },
    { name: 'la-mask', prefix: 'las', tags: ['social', 'web'] },
    { name: 'la-mastodon', prefix: 'lab', tags: ['brand'] },
    { name: 'la-maxcdn', prefix: 'lab', tags: ['brand'] },
    { name: 'la-mdb', prefix: 'lab', tags: ['brand'] },
    { name: 'la-medal', prefix: 'las', tags: ['social'] },
    { name: 'la-medapps', prefix: 'lab', tags: ['brand'] },
    { name: 'la-medium', prefix: 'lab', tags: ['brand'] },
    { name: 'la-medium-m', prefix: 'lab', tags: ['brand'] },
    { name: 'la-medkit', prefix: 'las', tags: ['health'] },
    { name: 'la-medrt', prefix: 'lab', tags: ['brand'] },
    { name: 'la-meetup', prefix: 'lab', tags: ['brand'] },
    { name: 'la-megaport', prefix: 'lab', tags: ['brand'] },
    { name: 'la-meh', prefix: 'las', tags: ['emotions'] },
    { name: 'la-meh-blank', prefix: 'las', tags: ['emotions'] },
    { name: 'la-meh-rolling-eyes', prefix: 'las', tags: ['emotions'] },
    { name: 'la-memory', prefix: 'las', tags: ['computer'] },
    { name: 'la-mendeley', prefix: 'lab', tags: ['brand'] },
    { name: 'la-menorah', prefix: 'las', tags: [] },
    { name: 'la-mercury', prefix: 'las', tags: [] },
    { name: 'la-meteor', prefix: 'las', tags: [] },
    { name: 'la-microchip', prefix: 'las', tags: [] },
    { name: 'la-microphone', prefix: 'las', tags: ['media'] },
    { name: 'la-microphone-alt', prefix: 'las', tags: ['media'] },
    { name: 'la-microphone-alt-slash', prefix: 'las', tags: ['media'] },
    { name: 'la-microphone-slash', prefix: 'las', tags: ['media'] },
    { name: 'la-microscope', prefix: 'las', tags: [] },
    { name: 'la-microsoft', prefix: 'lab', tags: ['brand'] },
    { name: 'la-minus', prefix: 'las', tags: [] },
    { name: 'la-minus-circle', prefix: 'las', tags: [] },
    { name: 'la-minus-square', prefix: 'las', tags: [] },
    { name: 'la-mitten', prefix: 'las', tags: [] },
    { name: 'la-mix', prefix: 'lab', tags: ['brand'] },
    { name: 'la-mixcloud', prefix: 'lab', tags: ['brand'] },
    { name: 'la-mizuni', prefix: 'lab', tags: ['brand'] },
    { name: 'la-mobile', prefix: 'las', tags: [] },
    { name: 'la-mobile-alt', prefix: 'las', tags: [] },
    { name: 'la-modx', prefix: 'lab', tags: ['brand'] },
    { name: 'la-monero', prefix: 'lab', tags: ['brand'] },
    { name: 'la-money-bill', prefix: 'las', tags: [] },
    { name: 'la-money-bill-alt', prefix: 'las', tags: [] },
    { name: 'la-money-bill-wave', prefix: 'las', tags: [] },
    { name: 'la-money-bill-wave-alt', prefix: 'las', tags: [] },
    { name: 'la-money-check', prefix: 'las', tags: [] },
    { name: 'la-money-check-alt', prefix: 'las', tags: [] },
    { name: 'la-monument', prefix: 'las', tags: [] },
    { name: 'la-moon', prefix: 'las', tags: [] },
    { name: 'la-mortar-pestle', prefix: 'las', tags: [] },
    { name: 'la-mosque', prefix: 'las', tags: [] },
    { name: 'la-motorcycle', prefix: 'las', tags: ['travel'] },
    { name: 'la-mountain', prefix: 'las', tags: [] },
    { name: 'la-mouse', prefix: 'las', tags: [] },
    { name: 'la-mouse-pointer', prefix: 'las', tags: ['arrow'] },
    { name: 'la-mug-hot', prefix: 'las', tags: [] },
    { name: 'la-music', prefix: 'las', tags: ['media'] },
    { name: 'la-napster', prefix: 'lab', tags: ['brand'] },
    { name: 'la-neos', prefix: 'lab', tags: ['brand'] },
    { name: 'la-network-wired', prefix: 'las', tags: [] },
    { name: 'la-neuter', prefix: 'las', tags: [] },
    { name: 'la-newspaper', prefix: 'las', tags: [] },
    { name: 'la-nimblr', prefix: 'lab', tags: ['brand'] },
    { name: 'la-node', prefix: 'lab', tags: ['brand'] },
    { name: 'la-node-js', prefix: 'lab', tags: ['brand'] },
    { name: 'la-not-equal', prefix: 'las', tags: [] },
    { name: 'la-notes-medical', prefix: 'las', tags: [] },
    { name: 'la-npm', prefix: 'lab', tags: ['brand'] },
    { name: 'la-ns8', prefix: 'lab', tags: ['brand'] },
    { name: 'la-nutritionix', prefix: 'lab', tags: ['brand'] },
    { name: 'la-object-group', prefix: 'las', tags: [] },
    { name: 'la-object-ungroup', prefix: 'las', tags: [] },
    { name: 'la-odnoklassniki', prefix: 'lab', tags: ['brand'] },
    { name: 'la-odnoklassniki-square', prefix: 'lab', tags: ['brand'] },
    { name: 'la-oil-can', prefix: 'las', tags: ['travel'] },
    { name: 'la-old-republic', prefix: 'lab', tags: ['brand'] },
    { name: 'la-om', prefix: 'las', tags: [] },
    { name: 'la-opencart', prefix: 'lab', tags: ['brand'] },
    { name: 'la-openid', prefix: 'lab', tags: ['brand'] },
    { name: 'la-opera', prefix: 'lab', tags: ['brand'] },
    { name: 'la-optin-monster', prefix: 'lab', tags: ['brand'] },
    { name: 'la-orcid', prefix: 'lab', tags: ['brand'] },
    { name: 'la-osi', prefix: 'las', tags: [] },
    { name: 'la-otter', prefix: 'las', tags: ['nature'] },
    { name: 'la-outdent', prefix: 'las', tags: [] },
    { name: 'la-page4', prefix: 'lab', tags: ['brand'] },
    { name: 'la-pagelines', prefix: 'lab', tags: ['brand'] },
    { name: 'la-pager', prefix: 'las', tags: [] },
    { name: 'la-paint-brush', prefix: 'las', tags: [] },
    { name: 'la-paint-roller', prefix: 'las', tags: [] },
    { name: 'la-palette', prefix: 'las', tags: [] },
    { name: 'la-palfed', prefix: 'lab', tags: ['brand'] },
    { name: 'la-pallet', prefix: 'las', tags: [] },
    { name: 'la-paper-plane', prefix: 'las', tags: [] },
    { name: 'la-paperclip', prefix: 'las', tags: [] },
    { name: 'la-parachute-box', prefix: 'las', tags: [] },
    { name: 'la-paragraph', prefix: 'las', tags: [] },
    { name: 'la-parking', prefix: 'las', tags: [] },
    { name: 'la-passport', prefix: 'las', tags: [] },
    { name: 'la-pastafarianism', prefix: 'las', tags: [] },
    { name: 'la-paste', prefix: 'las', tags: [] },
    { name: 'la-patreon', prefix: 'lab', tags: ['brand'] },
    { name: 'la-pause', prefix: 'las', tags: ['media'] },
    { name: 'la-pause-circle', prefix: 'las', tags: ['media'] },
    { name: 'la-paw', prefix: 'las', tags: ['nature'] },
    { name: 'la-paypal', prefix: 'lab', tags: ['brand'] },
    { name: 'la-peace', prefix: 'las', tags: [] },
    { name: 'la-pen', prefix: 'las', tags: [] },
    { name: 'la-pen-alt', prefix: 'las', tags: [] },
    { name: 'la-pen-fancy', prefix: 'las', tags: [] },
    { name: 'la-pen-nib', prefix: 'las', tags: [] },
    { name: 'la-pen-square', prefix: 'las', tags: [] },
    { name: 'la-pencil-alt', prefix: 'las', tags: [] },
    { name: 'la-pencil-ruler', prefix: 'las', tags: [] },
    { name: 'la-penny-arcade', prefix: 'lab', tags: ['brand'] },
    { name: 'la-people-carry', prefix: 'las', tags: [] },
    { name: 'la-pepper-hot', prefix: 'las', tags: [] },
    { name: 'la-percent', prefix: 'las', tags: [] },
    { name: 'la-percentage', prefix: 'las', tags: [] },
    { name: 'la-periscope', prefix: 'lab', tags: ['brand'] },
    { name: 'la-person-booth', prefix: 'las', tags: [] },
    { name: 'la-phabricator', prefix: 'lab', tags: ['brand'] },
    { name: 'la-phoenix-framework', prefix: 'lab', tags: ['brand'] },
    { name: 'la-phoenix-squadron', prefix: 'lab', tags: ['brand'] },
    { name: 'la-phone', prefix: 'las', tags: [] },
    { name: 'la-phone-alt', prefix: 'las', tags: [] },
    { name: 'la-phone-slash', prefix: 'las', tags: [] },
    { name: 'la-phone-square', prefix: 'las', tags: [] },
    { name: 'la-phone-square-alt', prefix: 'las', tags: [] },
    { name: 'la-phone-volume', prefix: 'las', tags: ['accessibility'] },
    { name: 'la-photo-video', prefix: 'las', tags: [] },
    { name: 'la-php', prefix: 'lab', tags: ['brand'] },
    { name: 'la-pied-piper', prefix: 'lab', tags: ['brand'] },
    { name: 'la-pied-piper-alt', prefix: 'lab', tags: ['brand'] },
    { name: 'la-pied-piper-hat', prefix: 'lab', tags: ['brand'] },
    { name: 'la-pied-piper-pp', prefix: 'lab', tags: ['brand'] },
    { name: 'la-piggy-bank', prefix: 'las', tags: [] },
    { name: 'la-pills', prefix: 'las', tags: [] },
    { name: 'la-pinterest', prefix: 'lab', tags: ['brand'] },
    { name: 'la-pinterest-p', prefix: 'lab', tags: ['brand'] },
    { name: 'la-pinterest-square', prefix: 'lab', tags: ['brand'] },
    { name: 'la-pizza-slice', prefix: 'las', tags: [] },
    { name: 'la-place-of-worship', prefix: 'las', tags: [] },
    { name: 'la-plane', prefix: 'las', tags: [] },
    { name: 'la-plane-arrival', prefix: 'las', tags: [] },
    { name: 'la-plane-departure', prefix: 'las', tags: [] },
    { name: 'la-play', prefix: 'las', tags: ['arrow', 'media'] },
    { name: 'la-play-circle', prefix: 'las', tags: ['media'] },
    { name: 'la-playstation', prefix: 'lab', tags: ['brand'] },
    { name: 'la-plug', prefix: 'las', tags: [] },
    { name: 'la-plus', prefix: 'las', tags: [] },
    { name: 'la-plus-circle', prefix: 'las', tags: [] },
    { name: 'la-plus-square', prefix: 'las', tags: [] },
    { name: 'la-podcast', prefix: 'las', tags: ['media'] },
    { name: 'la-poll', prefix: 'las', tags: [] },
    { name: 'la-poll-h', prefix: 'las', tags: [] },
    { name: 'la-poo', prefix: 'las', tags: [] },
    { name: 'la-poo-storm', prefix: 'las', tags: [] },
    { name: 'la-poop', prefix: 'las', tags: [] },
    { name: 'la-portrait', prefix: 'las', tags: [] },
    { name: 'la-pound-sign', prefix: 'las', tags: [] },
    { name: 'la-power-off', prefix: 'las', tags: [] },
    { name: 'la-pray', prefix: 'las', tags: [] },
    { name: 'la-praying-hands', prefix: 'las', tags: [] },
    { name: 'la-prescription', prefix: 'las', tags: [] },
    { name: 'la-prescription-bottle', prefix: 'las', tags: [] },
    { name: 'la-prescription-bottle-alt', prefix: 'las', tags: [] },
    { name: 'la-print', prefix: 'las', tags: [] },
    { name: 'la-procedures', prefix: 'las', tags: [] },
    { name: 'la-product-hunt', prefix: 'lab', tags: ['brand'] },
    { name: 'la-project-diagram', prefix: 'las', tags: [] },
    { name: 'la-pushed', prefix: 'lab', tags: ['brand'] },
    { name: 'la-puzzle-piece', prefix: 'las', tags: [] },
    { name: 'la-python', prefix: 'lab', tags: ['brand'] },
    { name: 'la-qq', prefix: 'lab', tags: ['brand'] },
    { name: 'la-qrcode', prefix: 'las', tags: [] },
    { name: 'la-question', prefix: 'las', tags: [] },
    { name: 'la-question-circle', prefix: 'las', tags: ['accessibility'] },
    { name: 'la-quidditch', prefix: 'las', tags: [] },
    { name: 'la-quinscape', prefix: 'lab', tags: ['brand'] },
    { name: 'la-quora', prefix: 'lab', tags: ['brand'] },
    { name: 'la-quote-left', prefix: 'las', tags: [] },
    { name: 'la-quote-right', prefix: 'las', tags: [] },
    { name: 'la-quran', prefix: 'las', tags: [] },
    { name: 'la-r-project', prefix: 'lab', tags: ['brand'] },
    { name: 'la-radiation', prefix: 'las', tags: [] },
    { name: 'la-radiation-alt', prefix: 'las', tags: [] },
    { name: 'la-rainbow', prefix: 'las', tags: [] },
    { name: 'la-random', prefix: 'las', tags: ['arrow', 'media'] },
    { name: 'la-raspberry-pi', prefix: 'lab', tags: ['brand'] },
    { name: 'la-ravelry', prefix: 'lab', tags: ['brand'] },
    { name: 'la-react', prefix: 'lab', tags: ['brand'] },
    { name: 'la-reacteurope', prefix: 'lab', tags: ['brand'] },
    { name: 'la-readme', prefix: 'lab', tags: ['brand'] },
    { name: 'la-rebel', prefix: 'lab', tags: ['brand'] },
    { name: 'la-receipt', prefix: 'las', tags: [] },
    { name: 'la-record-vinyl', prefix: 'las', tags: [] },
    { name: 'la-recycle', prefix: 'las', tags: ['arrow'] },
    { name: 'la-red-river', prefix: 'lab', tags: ['brand'] },
    { name: 'la-reddit', prefix: 'lab', tags: ['brand'] },
    { name: 'la-reddit-alien', prefix: 'lab', tags: ['brand'] },
    { name: 'la-reddit-square', prefix: 'lab', tags: ['brand'] },
    { name: 'la-redhat', prefix: 'lab', tags: ['brand'] },
    { name: 'la-redo', prefix: 'las', tags: ['arrow', 'media'] },
    { name: 'la-redo-alt', prefix: 'las', tags: ['arrow', 'media'] },
    { name: 'la-registered', prefix: 'las', tags: [] },
    { name: 'la-remove-format', prefix: 'las', tags: [] },
    { name: 'la-renren', prefix: 'lab', tags: ['brand'] },
    { name: 'la-reply', prefix: 'las', tags: ['arrow'] },
    { name: 'la-reply-all', prefix: 'las', tags: ['arrow'] },
    { name: 'la-replyd', prefix: 'lab', tags: ['brand'] },
    { name: 'la-republican', prefix: 'las', tags: [] },
    { name: 'la-researchgate', prefix: 'lab', tags: ['brand'] },
    { name: 'la-resolving', prefix: 'lab', tags: ['brand'] },
    { name: 'la-restroom', prefix: 'las', tags: [] },
    { name: 'la-retweet', prefix: 'las', tags: ['arrow'] },
    { name: 'la-rev', prefix: 'lab', tags: ['brand'] },
    { name: 'la-ribbon', prefix: 'las', tags: [] },
    { name: 'la-ring', prefix: 'las', tags: [] },
    { name: 'la-road', prefix: 'las', tags: [] },
    { name: 'la-robot', prefix: 'las', tags: [] },
    { name: 'la-rocket', prefix: 'las', tags: [] },
    { name: 'la-rocketchat', prefix: 'lab', tags: ['brand'] },
    { name: 'la-rockrms', prefix: 'lab', tags: ['brand'] },
    { name: 'la-route', prefix: 'las', tags: [] },
    { name: 'la-rss', prefix: 'las', tags: ['media'] },
    { name: 'la-rss-square', prefix: 'las', tags: ['media'] },
    { name: 'la-ruble-sign', prefix: 'las', tags: [] },
    { name: 'la-ruler', prefix: 'las', tags: [] },
    { name: 'la-ruler-combined', prefix: 'las', tags: [] },
    { name: 'la-ruler-horizontal', prefix: 'las', tags: [] },
    { name: 'la-ruler-vertical', prefix: 'las', tags: [] },
    { name: 'la-running', prefix: 'las', tags: [] },
    { name: 'la-rupee-sign', prefix: 'las', tags: [] },
    { name: 'la-sad-cry', prefix: 'las', tags: [] },
    { name: 'la-sad-tear', prefix: 'las', tags: [] },
    { name: 'la-safari', prefix: 'lab', tags: ['brand'] },
    { name: 'la-salesforce', prefix: 'lab', tags: ['brand'] },
    { name: 'la-sass', prefix: 'lab', tags: ['brand'] },
    { name: 'la-satellite', prefix: 'las', tags: [] },
    { name: 'la-satellite-dish', prefix: 'las', tags: [] },
    { name: 'la-save', prefix: 'las', tags: [] },
    { name: 'la-schlix', prefix: 'lab', tags: ['brand'] },
    { name: 'la-school', prefix: 'las', tags: [] },
    { name: 'la-screwdriver', prefix: 'las', tags: [] },
    { name: 'la-scribd', prefix: 'lab', tags: ['brand'] },
    { name: 'la-scroll', prefix: 'las', tags: [] },
    { name: 'la-sd-card', prefix: 'las', tags: [] },
    { name: 'la-search', prefix: 'las', tags: [] },
    { name: 'la-search-dollar', prefix: 'las', tags: [] },
    { name: 'la-search-location', prefix: 'las', tags: [] },
    { name: 'la-search-minus', prefix: 'las', tags: [] },
    { name: 'la-search-plus', prefix: 'las', tags: [] },
    { name: 'la-searchengin', prefix: 'lab', tags: ['brand'] },
    { name: 'la-seedling', prefix: 'las', tags: [] },
    { name: 'la-sellcast', prefix: 'lab', tags: ['brand'] },
    { name: 'la-sellsy', prefix: 'lab', tags: ['brand'] },
    { name: 'la-server', prefix: 'las', tags: [] },
    { name: 'la-servicestack', prefix: 'lab', tags: ['brand'] },
    { name: 'la-shapes', prefix: 'las', tags: [] },
    { name: 'la-share', prefix: 'las', tags: ['arrow'] },
    { name: 'la-share-alt', prefix: 'las', tags: ['arrow'] },
    { name: 'la-share-alt-square', prefix: 'las', tags: ['arrow'] },
    { name: 'la-share-square', prefix: 'las', tags: ['arrow'] },
    { name: 'la-shekel-sign', prefix: 'las', tags: [] },
    { name: 'la-shield-alt', prefix: 'las', tags: [] },
    { name: 'la-ship', prefix: 'las', tags: [] },
    { name: 'la-shipping-fast', prefix: 'las', tags: [] },
    { name: 'la-shirtsinbulk', prefix: 'lab', tags: ['brand'] },
    { name: 'la-shoe-prints', prefix: 'las', tags: [] },
    { name: 'la-shopping-bag', prefix: 'las', tags: [] },
    { name: 'la-shopping-basket', prefix: 'las', tags: [] },
    { name: 'la-shopping-cart', prefix: 'las', tags: [] },
    { name: 'la-shopware', prefix: 'lab', tags: ['brand'] },
    { name: 'la-shower', prefix: 'las', tags: [] },
    { name: 'la-shuttle-van', prefix: 'las', tags: ['travel'] },
    { name: 'la-sign', prefix: 'las', tags: [] },
    { name: 'la-sign-in-alt', prefix: 'las', tags: [] },
    { name: 'la-sign-language', prefix: 'las', tags: ['accessibility'] },
    { name: 'la-sign-out-alt', prefix: 'las', tags: [] },
    { name: 'la-signal', prefix: 'las', tags: [] },
    { name: 'la-signature', prefix: 'las', tags: [] },
    { name: 'la-sim-card', prefix: 'las', tags: [] },
    { name: 'la-simplybuilt', prefix: 'lab', tags: ['brand'] },
    { name: 'la-sistrix', prefix: 'lab', tags: ['brand'] },
    { name: 'la-sitemap', prefix: 'las', tags: [] },
    { name: 'la-sith', prefix: 'lab', tags: ['brand'] },
    { name: 'la-skating', prefix: 'las', tags: [] },
    { name: 'la-sketch', prefix: 'lab', tags: ['brand'] },
    { name: 'la-skiing', prefix: 'las', tags: [] },
    { name: 'la-skiing-nordic', prefix: 'las', tags: [] },
    { name: 'la-skull', prefix: 'las', tags: [] },
    { name: 'la-skull-crossbones', prefix: 'las', tags: [] },
    { name: 'la-skyatlas', prefix: 'lab', tags: ['brand'] },
    { name: 'la-skype', prefix: 'lab', tags: ['brand'] },
    { name: 'la-slack', prefix: 'lab', tags: ['brand'] },
    { name: 'la-slack-hash', prefix: 'lab', tags: ['brand'] },
    { name: 'la-slash', prefix: 'las', tags: [] },
    { name: 'la-sleigh', prefix: 'las', tags: [] },
    { name: 'la-sliders-h', prefix: 'las', tags: [] },
    { name: 'la-slideshare', prefix: 'lab', tags: ['brand'] },
    { name: 'la-smile', prefix: 'las', tags: [] },
    { name: 'la-smile-beam', prefix: 'las', tags: [] },
    { name: 'la-smile-wink', prefix: 'las', tags: [] },
    { name: 'la-smog', prefix: 'las', tags: [] },
    { name: 'la-smoking', prefix: 'las', tags: [] },
    { name: 'la-smoking-ban', prefix: 'las', tags: [] },
    { name: 'la-sms', prefix: 'las', tags: [] },
    { name: 'la-snapchat', prefix: 'lab', tags: ['brand'] },
    { name: 'la-snapchat-ghost', prefix: 'lab', tags: ['brand'] },
    { name: 'la-snapchat-square', prefix: 'lab', tags: ['brand'] },
    { name: 'la-snowboarding', prefix: 'las', tags: [] },
    { name: 'la-snowflake', prefix: 'las', tags: [] },
    { name: 'la-snowman', prefix: 'las', tags: [] },
    { name: 'la-snowplow', prefix: 'las', tags: [] },
    { name: 'la-socks', prefix: 'las', tags: [] },
    { name: 'la-solar-panel', prefix: 'las', tags: [] },
    { name: 'la-sort', prefix: 'las', tags: ['arrow'] },
    { name: 'la-sort-alpha-down', prefix: 'las', tags: ['arrow'] },
    { name: 'la-sort-alpha-down-alt', prefix: 'las', tags: ['arrow'] },
    { name: 'la-sort-alpha-up', prefix: 'las', tags: ['arrow'] },
    { name: 'la-sort-alpha-up-alt', prefix: 'las', tags: ['arrow'] },
    { name: 'la-sort-amount-down', prefix: 'las', tags: ['arrow'] },
    { name: 'la-sort-amount-down-alt', prefix: 'las', tags: ['arrow'] },
    { name: 'la-sort-amount-up', prefix: 'las', tags: ['arrow'] },
    { name: 'la-sort-amount-up-alt', prefix: 'las', tags: ['arrow'] },
    { name: 'la-sort-down', prefix: 'las', tags: ['arrow'] },
    { name: 'la-sort-numeric-down', prefix: 'las', tags: ['arrow'] },
    { name: 'la-sort-numeric-down-alt', prefix: 'las', tags: ['arrow'] },
    { name: 'la-sort-numeric-up', prefix: 'las', tags: ['arrow'] },
    { name: 'la-sort-numeric-up-alt', prefix: 'las', tags: ['arrow'] },
    { name: 'la-sort-up', prefix: 'las', tags: ['arrow'] },
    { name: 'la-soundcloud', prefix: 'lab', tags: ['brand'] },
    { name: 'la-sourcetree', prefix: 'lab', tags: ['brand'] },
    { name: 'la-spa', prefix: 'las', tags: [] },
    { name: 'la-space-shuttle', prefix: 'las', tags: [] },
    { name: 'la-speakap', prefix: 'lab', tags: ['brand'] },
    { name: 'la-speaker-deck', prefix: 'lab', tags: ['brand'] },
    { name: 'la-spell-check', prefix: 'las', tags: [] },
    { name: 'la-spider', prefix: 'las', tags: ['nature'] },
    { name: 'la-spinner', prefix: 'las', tags: [] },
    { name: 'la-splotch', prefix: 'las', tags: [] },
    { name: 'la-spotify', prefix: 'lab', tags: ['brand'] },
    { name: 'la-spray-can', prefix: 'las', tags: [] },
    { name: 'la-square', prefix: 'las', tags: [] },
    { name: 'la-square-full', prefix: 'las', tags: [] },
    { name: 'la-square-root-alt', prefix: 'las', tags: [] },
    { name: 'la-squarespace', prefix: 'lab', tags: ['brand'] },
    { name: 'la-stack-exchange', prefix: 'lab', tags: ['brand'] },
    { name: 'la-stack-overflow', prefix: 'lab', tags: ['brand'] },
    { name: 'la-stackpath', prefix: 'lab', tags: ['brand'] },
    { name: 'la-stamp', prefix: 'las', tags: [] },
    { name: 'la-star', prefix: 'las', tags: [] },
    { name: 'la-star-and-crescent', prefix: 'las', tags: [] },
    { name: 'la-star-half', prefix: 'las', tags: [] },
    { name: 'la-star-half-alt', prefix: 'las', tags: [] },
    { name: 'la-star-of-david', prefix: 'las', tags: [] },
    { name: 'la-star-of-life', prefix: 'las', tags: [] },
    { name: 'la-staylinked', prefix: 'lab', tags: ['brand'] },
    { name: 'la-steam', prefix: 'lab', tags: ['brand'] },
    { name: 'la-steam-square', prefix: 'lab', tags: ['brand'] },
    { name: 'la-steam-symbol', prefix: 'lab', tags: ['brand'] },
    { name: 'la-step-backward', prefix: 'las', tags: ['media'] },
    { name: 'la-step-forward', prefix: 'las', tags: ['media'] },
    { name: 'la-stethoscope', prefix: 'las', tags: [] },
    { name: 'la-sticker-mule', prefix: 'lab', tags: ['brand'] },
    { name: 'la-sticky-note', prefix: 'las', tags: [] },
    { name: 'la-stop', prefix: 'las', tags: ['media'] },
    { name: 'la-stop-circle', prefix: 'las', tags: ['media'] },
    { name: 'la-stopwatch', prefix: 'las', tags: [] },
    { name: 'la-store', prefix: 'las', tags: [] },
    { name: 'la-store-alt', prefix: 'las', tags: [] },
    { name: 'la-strava', prefix: 'lab', tags: ['brand'] },
    { name: 'la-stream', prefix: 'las', tags: [] },
    { name: 'la-street-view', prefix: 'las', tags: [] },
    { name: 'la-strikethrough', prefix: 'las', tags: [] },
    { name: 'la-stripe', prefix: 'lab', tags: ['brand'] },
    { name: 'la-stripe-s', prefix: 'lab', tags: ['brand'] },
    { name: 'la-stroopwafel', prefix: 'las', tags: [] },
    { name: 'la-studiovinari', prefix: 'lab', tags: ['brand'] },
    { name: 'la-stumbleupon', prefix: 'lab', tags: ['brand'] },
    { name: 'la-stumbleupon-circle', prefix: 'lab', tags: ['brand'] },
    { name: 'la-subscript', prefix: 'las', tags: [] },
    { name: 'la-subway', prefix: 'las', tags: [] },
    { name: 'la-suitcase', prefix: 'las', tags: [] },
    { name: 'la-suitcase-rolling', prefix: 'las', tags: [] },
    { name: 'la-sun', prefix: 'las', tags: [] },
    { name: 'la-superpowers', prefix: 'lab', tags: ['brand'] },
    { name: 'la-superscript', prefix: 'las', tags: [] },
    { name: 'la-supple', prefix: 'lab', tags: ['brand'] },
    { name: 'la-surprise', prefix: 'las', tags: [] },
    { name: 'la-suse', prefix: 'lab', tags: ['brand'] },
    { name: 'la-swatchbook', prefix: 'las', tags: [] },
    { name: 'la-swift', prefix: 'lab', tags: ['brand'] },
    { name: 'la-swimmer', prefix: 'las', tags: [] },
    { name: 'la-swimming-pool', prefix: 'las', tags: [] },
    { name: 'la-symfony', prefix: 'lab', tags: ['brand'] },
    { name: 'la-synagogue', prefix: 'las', tags: [] },
    { name: 'la-sync', prefix: 'las', tags: ['arrow', 'media'] },
    { name: 'la-sync-alt', prefix: 'las', tags: ['arrow', 'media'] },
    { name: 'la-syringe', prefix: 'las', tags: [] },
    { name: 'la-table', prefix: 'las', tags: [] },
    { name: 'la-table-tennis', prefix: 'las', tags: [] },
    { name: 'la-tablet', prefix: 'las', tags: [] },
    { name: 'la-tablet-alt', prefix: 'las', tags: [] },
    { name: 'la-tablets', prefix: 'las', tags: [] },
    { name: 'la-tachometer-alt', prefix: 'las', tags: ['travel'] },
    { name: 'la-tag', prefix: 'las', tags: [] },
    { name: 'la-tags', prefix: 'las', tags: [] },
    { name: 'la-tape', prefix: 'las', tags: [] },
    { name: 'la-tasks', prefix: 'las', tags: [] },
    { name: 'la-taxi', prefix: 'las', tags: ['travel'] },
    { name: 'la-teamspeak', prefix: 'lab', tags: ['brand'] },
    { name: 'la-teeth', prefix: 'las', tags: [] },
    { name: 'la-teeth-open', prefix: 'las', tags: [] },
    { name: 'la-telegram', prefix: 'lab', tags: ['brand'] },
    { name: 'la-telegram-plane', prefix: 'lab', tags: ['brand'] },
    { name: 'la-temperature-high', prefix: 'las', tags: [] },
    { name: 'la-temperature-low', prefix: 'las', tags: [] },
    { name: 'la-tencent-weibo', prefix: 'lab', tags: ['brand'] },
    { name: 'la-tenge', prefix: 'las', tags: [] },
    { name: 'la-terminal', prefix: 'las', tags: [] },
    { name: 'la-text-height', prefix: 'las', tags: ['arrow'] },
    { name: 'la-text-width', prefix: 'las', tags: ['arrow'] },
    { name: 'la-th', prefix: 'las', tags: [] },
    { name: 'la-th-large', prefix: 'las', tags: [] },
    { name: 'la-th-list', prefix: 'las', tags: [] },
    { name: 'la-the-red-yeti', prefix: 'lab', tags: ['brand'] },
    { name: 'la-theater-masks', prefix: 'las', tags: [] },
    { name: 'la-themeco', prefix: 'lab', tags: ['brand'] },
    { name: 'la-themeisle', prefix: 'lab', tags: ['brand'] },
    { name: 'la-thermometer', prefix: 'las', tags: [] },
    { name: 'la-thermometer-empty', prefix: 'las', tags: [] },
    { name: 'la-thermometer-full', prefix: 'las', tags: [] },
    { name: 'la-thermometer-half', prefix: 'las', tags: [] },
    { name: 'la-thermometer-quarter', prefix: 'las', tags: [] },
    { name: 'la-thermometer-three-quarters', prefix: 'las', tags: [] },
    { name: 'la-think-peaks', prefix: 'lab', tags: ['brand'] },
    { name: 'la-thumbs-down', prefix: 'las', tags: [] },
    { name: 'la-thumbs-up', prefix: 'las', tags: [] },
    { name: 'la-thumbtack', prefix: 'las', tags: [] },
    { name: 'la-ticket-alt', prefix: 'las', tags: [] },
    { name: 'la-times', prefix: 'las', tags: [] },
    { name: 'la-times-circle', prefix: 'las', tags: [] },
    { name: 'la-tint', prefix: 'las', tags: [] },
    { name: 'la-tint-slash', prefix: 'las', tags: [] },
    { name: 'la-tired', prefix: 'las', tags: [] },
    { name: 'la-toggle-off', prefix: 'las', tags: [] },
    { name: 'la-toggle-on', prefix: 'las', tags: [] },
    { name: 'la-toilet', prefix: 'las', tags: [] },
    { name: 'la-toilet-paper', prefix: 'las', tags: [] },
    { name: 'la-toolbox', prefix: 'las', tags: [] },
    { name: 'la-tools', prefix: 'las', tags: [] },
    { name: 'la-tooth', prefix: 'las', tags: [] },
    { name: 'la-torah', prefix: 'las', tags: [] },
    { name: 'la-torii-gate', prefix: 'las', tags: [] },
    { name: 'la-tractor', prefix: 'las', tags: [] },
    { name: 'la-trade-federation', prefix: 'lab', tags: ['brand'] },
    { name: 'la-trademark', prefix: 'las', tags: [] },
    { name: 'la-traffic-light', prefix: 'las', tags: [] },
    { name: 'la-train', prefix: 'las', tags: [] },
    { name: 'la-tram', prefix: 'las', tags: [] },
    { name: 'la-transgender', prefix: 'las', tags: [] },
    { name: 'la-transgender-alt', prefix: 'las', tags: [] },
    { name: 'la-trash', prefix: 'las', tags: [] },
    { name: 'la-trash-alt', prefix: 'las', tags: [] },
    { name: 'la-trash-restore', prefix: 'las', tags: [] },
    { name: 'la-trash-restore-alt', prefix: 'las', tags: [] },
    { name: 'la-tree', prefix: 'las', tags: [] },
    { name: 'la-trello', prefix: 'lab', tags: ['brand'] },
    { name: 'la-tripadvisor', prefix: 'lab', tags: ['brand'] },
    { name: 'la-trophy', prefix: 'las', tags: [] },
    { name: 'la-truck', prefix: 'las', tags: ['travel'] },
    { name: 'la-truck-loading', prefix: 'las', tags: ['travel'] },
    { name: 'la-truck-monster', prefix: 'las', tags: ['travel'] },
    { name: 'la-truck-moving', prefix: 'las', tags: ['travel'] },
    { name: 'la-truck-pickup', prefix: 'las', tags: ['travel'] },
    { name: 'la-tshirt', prefix: 'las', tags: [] },
    { name: 'la-tty', prefix: 'las', tags: ['accessibility'] },
    { name: 'la-tumblr', prefix: 'lab', tags: ['brand'] },
    { name: 'la-tumblr-square', prefix: 'lab', tags: ['brand'] },
    { name: 'la-tv', prefix: 'las', tags: ['media'] },
    { name: 'la-twitch', prefix: 'lab', tags: ['brand'] },
    { name: 'la-twitter', prefix: 'lab', tags: ['brand'] },
    { name: 'la-twitter-square', prefix: 'lab', tags: ['brand'] },
    { name: 'la-typo3', prefix: 'lab', tags: ['brand'] },
    { name: 'la-uber', prefix: 'lab', tags: ['brand'] },
    { name: 'la-ubuntu', prefix: 'lab', tags: ['brand'] },
    { name: 'la-uikit', prefix: 'lab', tags: ['brand'] },
    { name: 'la-umbraco', prefix: 'lab', tags: ['brand'] },
    { name: 'la-umbrella', prefix: 'las', tags: [] },
    { name: 'la-umbrella-beach', prefix: 'las', tags: [] },
    { name: 'la-underline', prefix: 'las', tags: [] },
    { name: 'la-undo', prefix: 'las', tags: ['arrow', 'media'] },
    { name: 'la-undo-alt', prefix: 'las', tags: ['arrow', 'media'] },
    { name: 'la-uniregistry', prefix: 'lab', tags: ['brand'] },
    { name: 'la-universal-access', prefix: 'las', tags: ['accessibility'] },
    { name: 'la-university', prefix: 'las', tags: [] },
    { name: 'la-unlink', prefix: 'las', tags: [] },
    { name: 'la-unlock', prefix: 'las', tags: [] },
    { name: 'la-unlock-alt', prefix: 'las', tags: [] },
    { name: 'la-untappd', prefix: 'lab', tags: ['brand'] },
    { name: 'la-upload', prefix: 'las', tags: ['arrow'] },
    { name: 'la-ups', prefix: 'lab', tags: ['brand'] },
    { name: 'la-usb', prefix: 'lab', tags: ['brand'] },
    { name: 'la-user', prefix: 'las', tags: [] },
    { name: 'la-user-alt', prefix: 'las', tags: [] },
    { name: 'la-user-alt-slash', prefix: 'las', tags: [] },
    { name: 'la-user-astronaut', prefix: 'las', tags: [] },
    { name: 'la-user-check', prefix: 'las', tags: [] },
    { name: 'la-user-circle', prefix: 'las', tags: [] },
    { name: 'la-user-clock', prefix: 'las', tags: [] },
    { name: 'la-user-cog', prefix: 'las', tags: [] },
    { name: 'la-user-edit', prefix: 'las', tags: [] },
    { name: 'la-user-friends', prefix: 'las', tags: [] },
    { name: 'la-user-graduate', prefix: 'las', tags: [] },
    { name: 'la-user-injured', prefix: 'las', tags: [] },
    { name: 'la-user-lock', prefix: 'las', tags: [] },
    { name: 'la-user-md', prefix: 'las', tags: [] },
    { name: 'la-user-minus', prefix: 'las', tags: [] },
    { name: 'la-user-ninja', prefix: 'las', tags: [] },
    { name: 'la-user-nurse', prefix: 'las', tags: [] },
    { name: 'la-user-plus', prefix: 'las', tags: [] },
    { name: 'la-user-secret', prefix: 'las', tags: [] },
    { name: 'la-user-shield', prefix: 'las', tags: [] },
    { name: 'la-user-slash', prefix: 'las', tags: [] },
    { name: 'la-user-tag', prefix: 'las', tags: [] },
    { name: 'la-user-tie', prefix: 'las', tags: [] },
    { name: 'la-user-times', prefix: 'las', tags: [] },
    { name: 'la-users', prefix: 'las', tags: [] },
    { name: 'la-users-cog', prefix: 'las', tags: [] },
    { name: 'la-usps', prefix: 'lab', tags: ['brand'] },
    { name: 'la-ussunnah', prefix: 'lab', tags: ['brand'] },
    { name: 'la-utensil-spoon', prefix: 'las', tags: [] },
    { name: 'la-utensils', prefix: 'las', tags: [] },
    { name: 'la-vaadin', prefix: 'lab', tags: ['brand'] },
    { name: 'la-vector-square', prefix: 'las', tags: [] },
    { name: 'la-venus', prefix: 'las', tags: [] },
    { name: 'la-venus-double', prefix: 'las', tags: [] },
    { name: 'la-venus-mars', prefix: 'las', tags: [] },
    { name: 'la-viacoin', prefix: 'lab', tags: ['brand'] },
    { name: 'la-viadeo', prefix: 'lab', tags: ['brand'] },
    { name: 'la-viadeo-square', prefix: 'lab', tags: ['brand'] },
    { name: 'la-vial', prefix: 'las', tags: [] },
    { name: 'la-vials', prefix: 'las', tags: [] },
    { name: 'la-viber', prefix: 'lab', tags: ['brand'] },
    { name: 'la-video', prefix: 'las', tags: ['media'] },
    { name: 'la-video-slash', prefix: 'las', tags: ['media'] },
    { name: 'la-vihara', prefix: 'las', tags: [] },
    { name: 'la-vimeo', prefix: 'lab', tags: ['brand'] },
    { name: 'la-vimeo-square', prefix: 'lab', tags: ['brand'] },
    { name: 'la-vimeo-v', prefix: 'lab', tags: ['brand'] },
    { name: 'la-vine', prefix: 'lab', tags: ['brand'] },
    { name: 'la-vk', prefix: 'lab', tags: ['brand'] },
    { name: 'la-vnv', prefix: 'lab', tags: ['brand'] },
    { name: 'la-voicemail', prefix: 'las', tags: [] },
    { name: 'la-volleyball-ball', prefix: 'las', tags: [] },
    { name: 'la-volume-down', prefix: 'las', tags: ['media'] },
    { name: 'la-volume-mute', prefix: 'las', tags: ['media'] },
    { name: 'la-volume-off', prefix: 'las', tags: ['media'] },
    { name: 'la-volume-up', prefix: 'las', tags: ['media'] },
    { name: 'la-vote-yea', prefix: 'las', tags: [] },
    { name: 'la-vr-cardboard', prefix: 'las', tags: [] },
    { name: 'la-vuejs', prefix: 'lab', tags: ['brand'] },
    { name: 'la-walking', prefix: 'las', tags: [] },
    { name: 'la-wallet', prefix: 'las', tags: [] },
    { name: 'la-warehouse', prefix: 'las', tags: [] },
    { name: 'la-water', prefix: 'las', tags: [] },
    { name: 'la-wave-square', prefix: 'las', tags: [] },
    { name: 'la-waze', prefix: 'lab', tags: ['brand'] },
    { name: 'la-weebly', prefix: 'lab', tags: ['brand'] },
    { name: 'la-weibo', prefix: 'lab', tags: ['brand'] },
    { name: 'la-weight', prefix: 'las', tags: [] },
    { name: 'la-weight-hanging', prefix: 'las', tags: [] },
    { name: 'la-weixin', prefix: 'lab', tags: ['brand'] },
    { name: 'la-whatsapp', prefix: 'lab', tags: ['brand'] },
    { name: 'la-whatsapp-square', prefix: 'lab', tags: ['brand'] },
    { name: 'la-wheelchair', prefix: 'las', tags: ['accessibility'] },
    { name: 'la-whmcs', prefix: 'lab', tags: ['brand'] },
    { name: 'la-wifi', prefix: 'las', tags: [] },
    { name: 'la-wikipedia-w', prefix: 'lab', tags: ['brand'] },
    { name: 'la-wind', prefix: 'las', tags: [] },
    { name: 'la-window-close', prefix: 'las', tags: [] },
    { name: 'la-window-maximize', prefix: 'las', tags: [] },
    { name: 'la-window-minimize', prefix: 'las', tags: [] },
    { name: 'la-window-restore', prefix: 'las', tags: [] },
    { name: 'la-windows', prefix: 'lab', tags: ['brand'] },
    { name: 'la-wine-bottle', prefix: 'las', tags: [] },
    { name: 'la-wine-glass', prefix: 'las', tags: [] },
    { name: 'la-wine-glass-alt', prefix: 'las', tags: [] },
    { name: 'la-wix', prefix: 'lab', tags: ['brand'] },
    { name: 'la-wizards-of-the-coast', prefix: 'lab', tags: ['brand'] },
    { name: 'la-wolf-pack-battalion', prefix: 'lab', tags: ['brand'] },
    { name: 'la-won-sign', prefix: 'las', tags: [] },
    { name: 'la-wordpress', prefix: 'lab', tags: ['brand'] },
    { name: 'la-wordpress-simple', prefix: 'lab', tags: ['brand'] },
    { name: 'la-wpbeginner', prefix: 'lab', tags: ['brand'] },
    { name: 'la-wpexplorer', prefix: 'lab', tags: ['brand'] },
    { name: 'la-wpforms', prefix: 'lab', tags: ['brand'] },
    { name: 'la-wpressr', prefix: 'lab', tags: ['brand'] },
    { name: 'la-wrench', prefix: 'las', tags: [] },
    { name: 'la-x-ray', prefix: 'las', tags: [] },
    { name: 'la-xbox', prefix: 'lab', tags: ['brand'] },
    { name: 'la-xing', prefix: 'lab', tags: ['brand'] },
    { name: 'la-xing-square', prefix: 'lab', tags: ['brand'] },
    { name: 'la-y-combinator', prefix: 'lab', tags: ['brand'] },
    { name: 'la-yahoo', prefix: 'lab', tags: ['brand'] },
    { name: 'la-yammer', prefix: 'lab', tags: ['brand'] },
    { name: 'la-yandex', prefix: 'lab', tags: ['brand'] },
    { name: 'la-yandex-international', prefix: 'lab', tags: ['brand'] },
    { name: 'la-yarn', prefix: 'lab', tags: ['brand'] },
    { name: 'la-yelp', prefix: 'lab', tags: ['brand'] },
    { name: 'la-yen-sign', prefix: 'las', tags: [] },
    { name: 'la-yin-yang', prefix: 'las', tags: [] },
    { name: 'la-yoast', prefix: 'lab', tags: ['brand'] },
    { name: 'la-youtube', prefix: 'lab', tags: ['brand', 'media'] },
    { name: 'la-youtube-square', prefix: 'lab', tags: ['brand', 'media'] },
    { name: 'la-zhihu', prefix: 'lab', tags: ['brand'] }
  ]
}
